'use strict';//Indicating browser should run only in java script mode
//(function () {
//    var typesToPatch = ['DocumentType', 'Element', 'CharacterData'],
//        remove = function () {
//            // The check here seems pointless, since we're not adding this
//            // method to the prototypes of any any elements that CAN be the
//            // root of the DOM. However, it's required by spec (see point 1 of
//            // https://dom.spec.whatwg.org/#dom-childnode-remove) and would
//            // theoretically make a difference if somebody .apply()ed this
//            // method to the DOM's root node, so let's roll with it.
//            if (this.parentNode != null) {
//                this.parentNode.removeChild(this);
//            }
//        };

//    for (var i = 0; i < typesToPatch.length; i++) {
//        var type = typesToPatch[i];
//        if (window[type] && !window[type].prototype.remove) {
//            window[type].prototype.remove = remove;
//        }
//    }
//})();


//angular.module('EMR.Admin').directive('myFocus', function () {
//    return {
//        restrict: 'A',
//        link: function (scope, element, attr) {
//            scope.$watch(attr.myFocus, function (n, o) {
//                if (n != 0 && n) {
//                    scope.$apply(element[0].focus());
//                }
//            });
//        }
//    };
//});

//######### DEFAULT FOCUSING ON FILED BLOCK START ##############
//*******PURPOSE: this method is used to set the default focus on control
//*******CREATED BY: George D
//*******CREATED DATE: 07/30/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('focusOnDefault', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {

            $timeout(function () {
                if ($(window).width() > 1024) {
                    //  alert(element.input)
                    scope.$apply(element.focus());
                }
            }, 500);

        }
    });
}]);


angular.module('EMR.Admin').directive('timepickerehr', [function () {
    return ({
        link: function (scope, element, attrs) {

            $(element).timepicker({
                minuteStep: 5,
                defaultTime: "00:00"
            });

            //$timeout(function () {
            //    if ($(window).width() > 1024) {
            //        //  alert(element.input)
            //        scope.$apply(element.focus());
            //    }
            //}, 500);

        }
    });
}]);







//######### DEFAULT FOCUSING ON FILED BLOCK END ##############

//######### FOCUSING ON DEMAND IN A FILED BLOCK START ##############
//*******PURPOSE: this method is used to set the default focus on control
//*******CREATED BY: George D
//*******CREATED DATE: 07/30/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('focusOnDemand', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {

            if (!hasValue(attrs) || !hasValue(attrs.focusMe)) return false;

            var model = $parse(attrs.focusMe);

            function onBlur() {
                //console.log('blur')

                //modified by balakrishna.d on 09/21/2016 here commented timeout since while leaving the control no need of waiting so as to that removed the timeout
                $timeout(function () {
                    scope.$apply(model.assign(scope, false));
                });
            }

            var unbindWatch = scope.$watch(model, function (value) {
                //console.log('value=', value);
                if (value === true) {
                    $timeout(function () {
                        if ($(window).width() > 1024) {
                            scope.$apply(element[0].focus());
                        }
                    }, 100);//changed the timer from 500 to  100
                }
            });
            element.bind('blur', onBlur);

            element.on('$destroy', function () {
                element.off('blur', onBlur);//removing event
                unbindWatch();//unbinding watch
            });
        }
    });
}]);

//written by mahesh p on 03/18/2017 for show/hide based on the flag
angular.module('EMR.Admin').directive('emrShow', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {

            angular.element(element).css({ "visibility": "hidden" });

            if (!hasValue(attrs) || !hasValue(attrs.emrShow)) return false;

            var model = $parse(attrs.emrShow);

            var unbindWatch = scope.$watch(model, function (value) {
                //console.log('value=', value);
                if (value === true) {
                    angular.element(element).css({ "visibility": "visible" });
                }
                else
                    angular.element(element).css({ "visibility": "hidden" });
            });

            element.on('$destroy', function () {
                unbindWatch();//unbinding watch
            });
        }
    });
}]);

//written by mahesh p on 03/18/2017 for show/hide based on the flag
angular.module('EMR.Admin').directive('emrHide', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {

            angular.element(element).css({ "visibility": "visible" });

            if (!hasValue(attrs) || !hasValue(attrs.emrHide)) return false;

            var model = $parse(attrs.emrHide);

            var unbindWatch = scope.$watch(model, function (value) {
                //console.log('value=', value);
                if (value === true) {
                    angular.element(element).css({ "visibility": "hidden" });
                }
                else
                    angular.element(element).css({ "visibility": "visible" });
            });

            element.on('$destroy', function () {
                unbindWatch();//unbinding watch
            });
        }
    });
}]);
//######### FOCUSING ON DEMAND IN A FILED BLOCK END ##############


//http://stackoverflow.com/questions/17470790/how-to-use-a-keypress-event-in-angularjs
//element.bind("keydown keypress", keyEvent);

//element.on('$destroy', function () {
//    element.off('keydown keypress', keyEvent);//removing event 
//});
//stopping the user to hold or continously pressing the ENTER button in 1sec span
angular.module('EMR.Admin').directive('ngEnter', function () {
    return function (scope, element, attrs) {
        if (!attrs.hasOwnProperty('ngEnter') || !attrs.ngEnter.trim()) {
            return;
        }

        let eventKeys = attrs.eventkeys ? attrs.eventkeys.trim() : "keydown keypress";
        let keyPressed = false;
        let cooldownTime = 1000; // cooldown in milliseconds
        let lastExecutedTime = 0;

        element.on(eventKeys, function (event) {
            if (event.which === 13) {
                let currentTime = Date.now();
                
                if (!keyPressed && (currentTime - lastExecutedTime) >= cooldownTime) {
                    keyPressed = true;
                    lastExecutedTime = currentTime;

                    if (!scope.$$phase) {
                        scope.$applyAsync(function () {
                            scope.$eval(attrs.ngEnter);
                        });
                    } else {
                        scope.$eval(attrs.ngEnter);
                    }
                }
                event.preventDefault();
            }
        });

        element.on("keyup", function (event) {
            if (event.which === 13) {
                keyPressed = false;
            }
        });

        scope.$on('$destroy', function () {
            element.off(eventKeys);
            element.off("keyup");
        });
    };
});




//this is the template cache of the anchor list ng-class="getClass($index)"
EMRAdmin.run(['$templateCache', function ($templateCache) {
    $templateCache.put('emrAnchorList.html', '<div class="EMRAnchorListView"><ul class="visibleColumnWidthForEMRAnchorList"><li ng-repeat="item in emrListOptions.dataSource | limitTo : emrListOptions.visibleColumns">'
        + '<a ng-if="!emrListOptions.visibleMultiLine"  ng-click="toggleSelect($index);toggleSelectChange($event,this.item);">{{item[emrListOptions.columns[0].field]}}</a><label class="anchListLabelHoverClass" ng-if="emrListOptions.visibleMultiLine"  ng-click="toggleSelect($index);toggleSelectChange($event,this.item);">{{item[emrListOptions.columns[0].field]}}</label></li></ul></div>');
}]);


// this directive is created by mahesh p on 01/12/2015
/// using of this directive
/// in HTML : <div emr-anchor-list options="listOptions"></div>
/// in Controller : $scope.listOptions={dataSource: dataToBind,columns:[{field:'columnToDisplay'},change: function(e){//on changing the selection in the grid get the selected item in e}] };
/// this directive is useful in displaying the anchor tags list
angular.module('EMR.Admin').directive('emrAnchorList', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'emrAnchorList.html',
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            emrListOptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },
        link: {

            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

                //if (iElement.find("style").length === 0) {
                //    var css = '<style>@media only screen and (max-width: 760px),(min-device-width: 768px) and (max-device-width: 1024px){\n'; //for mobile resolution
                //    css += '';
                //    iElement.html(css); //adding css to the current element
                //}

                if (scope.emrListOptions != undefined && (scope.emrListOptions.visibleWidth != undefined || scope.emrListOptions.visibleWidth != null)) {
                    scope.visibleColumnWidthForAnchorList = "width :" + scope.emrListOptions.visibleWidth.toString() + "px;";
                    iElement.find("ul").css({ "width": scope.emrListOptions.visibleWidth.toString() + "px" });
                }
                else {
                    scope.visibleColumnWidthForAnchorList = "width : auto";
                    iElement.find("ul").css({ "width": "auto" });
                }

                // Condition Added for Multi Line to Anchor LIst by Sandhya G on 30/03/2020
                // if visibleMultiLine: true then Following Style will be applied for Multiple line
                if (scope.emrListOptions != undefined && (scope.emrListOptions.visibleMultiLine != undefined || scope.emrListOptions.visibleMultiLine != null)) {
                    iElement.find("ul").css({ "white-space": "normal" });
                    iElement.find("ul li").css({ "display": "inline-flex" });
                }
                // if visibleMultiLine: false then Following Style will be applied for Multiple line
                else {
                    iElement.find("ul").css({ "white-space": "nowrap" });
                    iElement.find("ul li").css({ "display": "inline" });
                }
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {
                //for maintaining the selected index of the item
                scope.emrListOptions.setSelectedItem = -1;//default setting the index of the selected item 

                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrListOptions.dataSource', function () {
                    scope.emrListOptions.setSelectedItem = -1;//setting default on changing the datasource
                });

                //making the selected element as the active by making the previous as unselected
                scope.toggleSelect = function (ind) {
                    //event.preventDefault();//preventing the defaults
                    if (ind === scope.emrListOptions.setSelectedItem) {
                        scope.emrListOptions.setSelectedItem = -1;
                    } else {
                        scope.emrListOptions.setSelectedItem = ind;
                    }
                }
                ////this method is useful in returning the class of the selected item in the anchor list to apply as the selected
                //scope.getClass = function (ind) {
                //    // event.preventDefault();//preventing the defaults
                //    if (ind === scope.emrListOptions.setSelectedItem) {
                //        return "label label-info";//returning the selection 
                //    } else {
                //        return "";//returning nothing for rest
                //    }
                //}

                scope.toggleSelectChange = function (event, item) {

                    angular.element(event.currentTarget).parents('div.EMRAnchorListView').find(".label-infoanchorbrown").removeClass("label-infoanchorbrown");
                    angular.element(event.currentTarget).addClass("label-infoanchorbrown");

                    scope.emrListOptions.change(item);
                }

                iElement.on('$destroy', function () {
                    unbindWatch();//unbinding watch
                });

            }
        }
    })
});




//this is the template cache of the anchor list ng-class="getClass($index)"
EMRAdmin.run(['$templateCache', function ($templateCache) {
    $templateCache.put('emrAnchorList2.html', '<div class="EMRAnchorListView"><ul class="visibleColumnWidthForEMRAnchorList"><li ng-repeat="item in emrListOptions.dataSource | limitTo : emrListOptions.visibleColumns">'
        + '<a ng-if="!emrListOptions.visibleMultiLine" title="{{item[emrListOptions.title]}}"  ng-click="toggleSelect($index);toggleSelectChange($event,this.item);">{{item[emrListOptions.columns[0].field]}}</a><label class="anchListLabelHoverClass" ng-if="emrListOptions.visibleMultiLine" title="{{item[emrListOptions.title]}}"  ng-click="toggleSelect($index);toggleSelectChange($event,this.item);">{{item[emrListOptions.columns[0].field]}}</label></li></ul></div>');
}]);


// this directive is created by mahesh p on 01/12/2015
/// using of this directive
/// in HTML : <div emr-anchor-list options="listOptions"></div>
/// in Controller : $scope.listOptions={dataSource: dataToBind,columns:[{field:'columnToDisplay'},change: function(e){//on changing the selection in the grid get the selected item in e}] };
/// this directive is useful in displaying the anchor tags list
angular.module('EMR.Admin').directive('emrAnchorListTitle', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'emrAnchorList2.html',
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            emrListOptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },
        link: {

            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

                //if (iElement.find("style").length === 0) {
                //    var css = '<style>@media only screen and (max-width: 760px),(min-device-width: 768px) and (max-device-width: 1024px){\n'; //for mobile resolution
                //    css += '';
                //    iElement.html(css); //adding css to the current element
                //}
                if (scope.emrListOptions != undefined && (scope.emrListOptions.visibleWidth != undefined || scope.emrListOptions.visibleWidth != null)) {
                    scope.visibleColumnWidthForAnchorList = "width :" + scope.emrListOptions.visibleWidth.toString() + "px";
                    iElement.find("ul").css({ "width": scope.emrListOptions.visibleWidth.toString() + "px" });
                }
                else {
                    scope.visibleColumnWidthForAnchorList = "width : auto";
                    iElement.find("ul").css({ "width": "auto" });
                }
                // Condition Added for Multi Line to Anchor LIst by Sandhya G on 30/03/2020
                // if visibleMultiLine: true then Following Style will be applied for Multiple line
                if (scope.emrListOptions != undefined && (scope.emrListOptions.visibleMultiLine != undefined || scope.emrListOptions.visibleMultiLine != null)) {
                    iElement.find("ul").css({ "white-space": "normal" });
                    iElement.find("ul li").css({ "display": "inline-flex" });
                }
                // if visibleMultiLine: false then Following Style will be applied for Multiple line
                else {
                    iElement.find("ul").css({ "white-space": "nowrap" });
                    iElement.find("ul li").css({ "display": "inline" });
                }
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {
                //for maintaining the selected index of the item
                scope.emrListOptions.setSelectedItem = -1;//default setting the index of the selected item 

                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrListOptions.visibleWidth', function () {
                    iElement.find("ul").css({ "width": scope.emrListOptions.visibleWidth.toString() + "px;" });
                    iElement.find("ul").width(scope.emrListOptions.visibleWidth.toString());
                    scope.visibleColumnWidthForAnchorList = "width :" + scope.emrListOptions.visibleWidth.toString() + "px;";
                    scope.emrListOptions.setSelectedItem = -1;//setting default on changing the datasource
                });

                //making the selected element as the active by making the previous as unselected
                scope.toggleSelect = function (ind) {
                    //event.preventDefault();//preventing the defaults
                    if (ind === scope.emrListOptions.setSelectedItem) {
                        scope.emrListOptions.setSelectedItem = -1;
                    } else {
                        scope.emrListOptions.setSelectedItem = ind;
                    }
                }

                scope.toggleSelectChange = function (event, item) {

                    angular.element(event.currentTarget).parents('div.EMRAnchorListView').find(".label-infoanchorbrown").removeClass("label-infoanchorbrown");
                    angular.element(event.currentTarget).addClass("label-infoanchorbrown");

                    scope.emrListOptions.change(this.item);
                }

                //this method is useful in returning the class of the selected item in the anchor list to apply as the selected
                //scope.getClass = function (ind) {
                //    // event.preventDefault();//preventing the defaults
                //    if (ind === scope.emrListOptions.setSelectedItem) {
                //        return "label label-info";//returning the selection 
                //    } else {
                //        return "";//returning nothing for rest
                //    }
                //}

                iElement.on('$destroy', function () {
                    unbindWatch();//unbinding watch
                });

            }
        }
    })
});



//this is the template cache of the emr grid type list with change event
EMRAdmin.run(['$templateCache', function ($templateCache) {

    $templateCache.put('emrGridList.html', "<div><ul class=\"EMRListGridRow\" tabindex={{$index}} style=\"-webkit-padding-start:5px;cursor : pointer;\"  ng-repeat=\"item in emrGridListOptions.dataSource track by $index\">" +
    "<li class=\"EMRListGridCellDiv\" ng-click=\"toggleGridListSelect($index,$event);emrGridListOptions.change(this.item, this);\"><div class=\"pull-left\"><span ng-if=\"item.IsMakeItBold\"><b>{{item[emrGridListOptions.columns[0].field]}}</b></span><span ng-if=\"!item.IsMakeItBold\">{{item[emrGridListOptions.columns[0].field]}}</span></li></ul></div>");

}]);


// this directive is created by mahesh p on 01/12/2015
/// using of this directive
/// in HTML : <div emr-anchor-list options="listOptions"></div>
/// in Controller : $scope.listOptions={dataSource: dataToBind,columns:[{field:'columnToDisplay'},change: function(e){//on changing the selection in the grid get the selected item in e}] };ng-class=\"getListClass($index)\"
/// this directive is useful in displaying the anchor tags list
angular.module('EMR.Admin').directive('emrGridList', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'emrGridList.html',
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            emrGridListOptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },
        link: {

            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {
                //for maintaining the selected index of the item
                scope.emrGridListOptions.setSelectedListItem = -1;//default setting the index of the selected item 

                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrGridListOptions.dataSource', function () {
                    scope.emrGridListOptions.setSelectedListItem = -1;//setting default on changing the datasource
                });

                //making the selected element as the active by making the previous as unselected
                scope.toggleGridListSelect = function (ind, event) {
                    angular.element(event.currentTarget.parentElement.parentElement).find(".k-state-selectedCustomOriented").removeClass("k-state-selectedCustomOriented");
                    angular.element(event.currentTarget).addClass("k-state-selectedCustomOriented");
                    //event.preventDefault();//preventing the defaults
                    //if (ind === scope.emrGridListOptions.setSelectedItem) {
                    //    scope.emrGridListOptions.setSelectedListItem = -1;
                    //} else {
                    //    scope.emrGridListOptions.setSelectedListItem = ind;
                    //}
                }
                //this method is useful in returning the class of the selected item in the anchor list to apply as the selected
                //scope.getListClass = function (ind) {
                //    // event.preventDefault();//preventing the defaults
                //    if (ind === scope.emrGridListOptions.setSelectedListItem) {
                //        return "EMRListGridCellDiv k-state-selected";//returning the selection 
                //    } else {
                //        return "EMRListGridCellDiv";//returning nothing for rest
                //    }
                //}

                iElement.on('$destroy', function () {
                    unbindWatch();//unbinding watch
                });
            }
        }
    })
});

//this is the template cache for the emr multi column list
EMRAdmin.run(['$templateCache', function ($templateCache) {
    $templateCache.put('EMRMultiColumnListView.html', '<div class="EMRMultiColumnListView"><ul><li ng-repeat="item in EMRMultiColumnLisOptions.dataSource">'
		+ '<input type="checkbox" ng-click="toggleSelect(this.item,$index,$event)" id="chkBox{{$index}}"/><label for="chkBox{{$index}}">{{item[EMRMultiColumnLisOptions.columns[0].field]}}</label></li></ul>');
}]);

///this directive is useful in generating the multi columns checkbox list for the given data source
/// In HTML :  <div emr-multi-column-list options="listOptions"></div>
/// in Controller :  $scope.listOptions={dataSource : $scope.jsonListToBind,columns:[field : "field To Display"],multiselect : false ,columnsCount: 4,selectedItems : $scope.listOfSelectedItems//for getting the selected or checked items };

angular.module('EMR.Admin').directive('emrMultiColumnList', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'EMRMultiColumnListView.html',
        scope: {
            EMRMultiColumnLisOptions: '=options',//getting the options from the user
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {
                var strCount = scope.EMRMultiColumnLisOptions.columnsCount.toString();//converting the int count value to string
                iElement.css({ "-moz-column-count": strCount, "-webkit-column-count": strCount, "column-count": strCount });//applying the no.of columns count as the user specified to display in the no.of columns
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {
                //this method is useful in making the single select columns                           
                scope.toggleSelect = function (itemSelected, ind, event) {
                    //single select case if the multi select is not specifieed
                    if (!scope.EMRMultiColumnLisOptions.multiselect || scope.EMRMultiColumnLisOptions.multiselect == undefined) {
                        scope.EMRMultiColumnLisOptions.selectedItems.unshift(itemSelected);//pushing into selection array for maintaining the selected items
                        //this method is fired when the user has clicked on the checkbox or it's respected label
                        iElement.find("input[type='checkbox']").click(function () {
                            iElement.find("input[type='checkbox']").not(this).removeAttr("checked");//removing the checked for all except the selected or clicked
                        });
                    }
                        //in case of multi select
                    else {
                        //the user can get this array at controller side for getting the selected items in the list
                        scope.EMRMultiColumnLisOptions.selectedItems.unshift(itemSelected);//pushing into selection array for maintaining the selected items 
                    }
                }
            }
        }
    })
});



//angular.module('EMR.Admin').directive('fullCallendar', function () {
//    return ({
//        restrict: 'E,A',
//        link: function (scope, element, attrs) {
//            element.fullCalendar({
//                theme: false,
//                header: {
//                    left: 'prev,next today',
//                    center: 'title',
//                    right: 'month,agendaWeek,agendaDay'
//                },
//                defaultDate: '2014-06-12',
//                editable: false,
//                eventBackgroundColor: '#278ccf',
//                events: [
//                    {
//                        title: 'All Day Event',
//                        start: '2014-06-01',
//                        isCheckedIn: false,
//                        isChargesCreated: false,
//                        isNotesCreated: false,
//                        MedReconStatus: 'N',
//                        isReminderSent: false,
//                        patientName: 'Test1',
//                        PatientDob: '12/12/1981'

//                    },
//        {
//            title: 'Long Event',
//            start: '2014-06-07',
//            end: '2014-06-10',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test2',
//            PatientDob: '12/12/1982'
//        },
//        {
//            id: 999,
//            title: 'Repeating Event',
//            start: '2014-06-09T16:00:00',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test3',
//            PatientDob: '12/12/1983'
//        },
//        {
//            id: 999,
//            title: 'Repeating Event',
//            start: '2014-06-16T16:00:00',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test4',
//            PatientDob: '12/12/1984'
//        },
//        {
//            title: 'Meeting',
//            start: '2014-06-12T10:30:00',
//            end: '2014-06-12T12:30:00',
//            isCheckedIn: true,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test5',
//            PatientDob: '12/12/1985'
//        },
//        {
//            title: 'Lunch',
//            start: '2014-06-12T12:00:00',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test6',
//            PatientDob: '12/12/1986'
//        },
//        {
//            title: 'My Event',
//            start: '2014-06-12T08:30:00',
//            end: '2014-06-12T09:00:00',
//            isCheckedIn: true,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test7',
//            PatientDob: '12/12/1987'
//        },
//        {
//            title: 'Birthday Party',
//            start: '2014-06-13T07:00:00',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test8',
//            PatientDob: '12/12/1988'
//        },
//        {
//            title: 'Click for Google',
//            url: 'http://google.com/',
//            start: '2014-06-28',
//            isCheckedIn: false,
//            isChargesCreated: false,
//            isNotesCreated: false,
//            MedReconStatus: 'N',
//            isReminderSent: false,
//            patientName: 'Test9',
//            PatientDob: '12/12/1989'
//        }
//                ],
//                dayClick: function () {
//                    alert('a day has been clicked!');
//                },
//                allDaySlot: false,
//                slotDuration: '00:15:00',
//                minTime: '08:00:00',
//                maxTime: '20:00:00',
//                slotEventOverlap: false,
//                //eventRender: function (event, element, view) {
//                //    //if (view.name == 'agendaDay') {
//                //    alert(event.title);
//                //    //}
//                //},
//            });

//            scope.$on('$destroy', function () {
//                //element.destroy();
//                //element.fullCalendar('destroy');
//                //element.remove();
//                element.fullCalendar('removeEvents');
//                element.fullCalendar('removeEventSources');
//                element.fullCalendar('destroy');



//            });

//        }
//    })
//});



//######### DESTROY ELEMENT BLOCK START ##############
//*******PURPOSE: this method is used to destroy element
//*******CREATED BY: George D
//*******CREATED DATE: 07/30/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('destroyElement', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {


            var elementsMainianted = attrs["destroyFields"];

            if (hasValue(elementsMainianted)) {

                element.on("$destroy", function () {

                    try {
                        var collection = $(elementsMainianted);
                        var collectionLen = collection.length;

                        for (var index = 0; index < collectionLen; index++) {
                            try {
                                angular.element(collection[index]).find("div:eq(0)").scope().$destroy();
                            } catch (e) {
                            }
                        }
                    } catch (e) {
                    }

                    element.off();
                    element.unbind();

                });

            }


            scope.$on('$destroy', function () {

                //try {

                //	var keysInScope = Object.keys(curScope);

                //	var keysLength = keysInScope.length;

                //	for (var i = 0; i < keysLength; i++) {
                //		if (keysInScope[i].toString().indexOf("$") < 0) {
                //			delete curScope[keysInScope[i]];
                //		}
                //	}

                //} catch (e) {

                //}

                //curScope = null;

                element.clearQueue();//It will clear all the child elements and its events of the current DIV

                //element.find("*").detachEvent();//removing all the events in the elements content

                //element.detachEvent();

                //var curScope;

                //try {
                //	curScope = angular.element(element).scope();
                //} catch (e) {

                //}



                if (element.find("iframe")) {

                    //try {

                    //    $(element.find("iframe")[0].contentWindow).unbind();
                    //    $(element.find("iframe")[0].contentWindow).undelegate();
                    //    $(element.find("iframe")[0].contentWindow).off();
                    //    $(element.find("iframe")[0].contentDocument).unbind().die();    //remove listeners on document
                    //    $(element.find("iframe")[0].contentDocument).find('*').unbind().die(); //remove listeners on all nodes
                    //    //clean up cookies
                    //} catch (e) {

                    //}

                    try {
                        ehrIframeDestroyElements(element);
                        element.find("iframe").attr("src", "");//unloading the previous src
                    } catch (e) {

                    }
                }

                if (element.children().find("iframe")) {

                    //try {


                    //    $(element.children().find("iframe")[0].contentWindow).unbind();
                    //    $(element.children().find("iframe")[0].contentWindow).undelegate();
                    //    $(element.children().find("iframe")[0].contentWindow).off();                        


                    //    $(element.children().find("iframe")[0].contentDocument).unbind().die();    //remove listeners on document
                    //    $(element.children().find("iframe")[0].contentDocument).find('*').unbind().die(); //remove listeners on all nodes
                    //    //clean up cookies
                    //    ///remove items from localStorage

                    //} catch (e) {

                    //}

                    //if (localStorage.length) {
                    //    localStorage.clear();//this removes the local storage of the web browser which is useful in clearing the previously viewed docs history removing
                    //    window.localStorage.clear();//this removes the local storage of the web browser which is useful in clearing the previously viewed docs history removing
                    //}

                    try {

                        ehrIframeDestroyElements(element.children());

                        element.children().find("iframe").attr("src", "");//unloading the previous src                   
                    } catch (e) {

                    }
                }



                element.children().remove();
                element.children().empty();

                element.contents().remove();


                element.contents().empty();
                element.closest("*").empty();
                //element.finish();

                element.children().off();
                element.find("*").unbind();//Removes an added event handler from selected elements
                element.find("*").undelegate();//Removes an event handler to selected elements, now or in the future
                element.find("*").off();//removing all the events in the elements content

                element.empty();//clearing all the child nodes in the div
                element.remove();//removing the current element
                //console.log("Element destroyed");
                //alert("Element destroyed")


                //try {
                //	curScope.$destroy();
                //} catch (e) {
                //}

                //curScope = null;

            });
        }
    });
}]);
//######### DESTROY ELEMENT BLOCK END ##############


//######### DESTROY ELEMENT BLOCK START ##############
//*******PURPOSE: this method is used to destroy element
//*******CREATED BY: George D
//*******CREATED DATE: 07/30/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('destroyElementBKP', ['$timeout', '$parse', function ($timeout, $parse) {
    return ({
        link: function (scope, element, attrs) {

            var curScope = scope;


            scope.$on('$destroy', function () {


                var collection, collectionLen;

                try {

                    collection = element.find('[kendo-multi-select],[kendo-drop-down-list],[kend-date-picker],[destroygrid]');
                    collectionLen = collection.length;

                    for (var index = 0; index < collectionLen; index++) {

                        try {
                            kendo.destroy(collection[index].getAttribute("id"));
                            kendo.destroy(collection[index]);
                        } catch (error) {
                            console.log("kendo error" + error);
                        }

                        //try {
                        //	var testing = angular.element(collection[index]).scope();

                        //	if (testing && !testing.$$destroyed && testing.$destroy)
                        //		angular.element(collection[index]).scope().$destroy();

                        //} catch (error) {
                        //	console.log("error" + error);
                        //}
                    }

                    collection.length = 0;

                } catch (e) {
                    console.log(e);
                }

                collection = null;
                collectionLen = null;


                //try {

                //	var keysInScope = Object.keys(curScope);

                //	var keysLength = keysInScope.length;

                //	for (var i = 0; i < keysLength; i++) {
                //		if (keysInScope[i].toString().indexOf("$") < 0) {
                //			delete curScope[keysInScope[i]];
                //		}
                //	}

                //} catch (e) {

                //}

                //curScope = null;

                element.clearQueue();//It will clear all the child elements and its events of the current DIV

                //element.find("*").detachEvent();//removing all the events in the elements content

                //element.detachEvent();

                //var curScope;

                //try {
                //	curScope = angular.element(element).scope();
                //} catch (e) {

                //}



                if (element.find("iframe")) {

                    //try {

                    //    $(element.find("iframe")[0].contentWindow).unbind();
                    //    $(element.find("iframe")[0].contentWindow).undelegate();
                    //    $(element.find("iframe")[0].contentWindow).off();
                    //    $(element.find("iframe")[0].contentDocument).unbind().die();    //remove listeners on document
                    //    $(element.find("iframe")[0].contentDocument).find('*').unbind().die(); //remove listeners on all nodes
                    //    //clean up cookies
                    //} catch (e) {

                    //}

                    try {
                        element.find("iframe").contents().find("*").unbind();//Removes an added event handler from selected elements
                        element.find("iframe").contents().find("*").undelegate();//Removes an event handler to selected elements, now or in the future
                        element.find("iframe").contents().find("*").off();//Removes an added event handler from selected elements
                        element.find("iframe").contents().find("*").remove();//removes contents elements of the iframe document
                        element.find("iframe").contents().find("*").empty();//removes all the data in the element
                        element.find("iframe").attr("src", "");//unloading the previous src
                    } catch (e) {

                    }



                }

                if (element.children().find("iframe")) {

                    //try {


                    //    $(element.children().find("iframe")[0].contentWindow).unbind();
                    //    $(element.children().find("iframe")[0].contentWindow).undelegate();
                    //    $(element.children().find("iframe")[0].contentWindow).off();                        


                    //    $(element.children().find("iframe")[0].contentDocument).unbind().die();    //remove listeners on document
                    //    $(element.children().find("iframe")[0].contentDocument).find('*').unbind().die(); //remove listeners on all nodes
                    //    //clean up cookies
                    //    ///remove items from localStorage

                    //} catch (e) {

                    //}

                    //if (localStorage.length) {
                    //    localStorage.clear();//this removes the local storage of the web browser which is useful in clearing the previously viewed docs history removing
                    //    window.localStorage.clear();//this removes the local storage of the web browser which is useful in clearing the previously viewed docs history removing
                    //}

                    try {
                        element.children().find("iframe").contents().find("*").unbind();//Removes an added event handler from selected elements
                        element.children().find("iframe").contents().find("*").undelegate();//Removes an event handler to selected elements, now or in the future
                        element.children().find("iframe").contents().find("*").off();//Removes an added event handler from selected elements
                        element.children().find("iframe").contents().find("*").remove();//removes contents elements of the iframe document
                        element.children().find("iframe").contents().find("*").empty();//removes all the data in the element
                        element.children().find("iframe").attr("src", "");//unloading the previous src                   
                    } catch (e) {

                    }
                }



                element.children().remove();
                element.children().empty();

                element.contents().remove();


                element.contents().empty();
                element.closest("*").empty();
                //element.finish();

                element.children().off();
                element.find("*").unbind();//Removes an added event handler from selected elements
                element.find("*").undelegate();//Removes an event handler to selected elements, now or in the future
                element.find("*").off();//removing all the events in the elements content

                element.empty();//clearing all the child nodes in the div
                element.remove();//removing the current element
                //console.log("Element destroyed");
                //alert("Element destroyed")


                //try {
                //	curScope.$destroy();
                //} catch (e) {
                //}

                //curScope = null;

            });
        }
    });
}]);
//######### DESTROY ELEMENT BLOCK END ##############

//######### APPLYING EMR FOCUS CLASS TO ELEMENT BLOCK START ##############
//*******PURPOSE:  this method is used to applying emr focus class to element when required. applying class on focusing element and removing class on leave of element
//*******CREATED BY: George D
//*******CREATED DATE: 02/20/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('emrFocusClass', function () {
    return ({
        restrict: 'A',
        link: function (scope, element) {
            element.focus(function () {
                element.addClass('EMRFocus');
            });
            element.blur(function () {
                element.removeClass('EMRFocus');
            });
        },
    });
});
//######### APPLYING EMR FOCUS CLASS TO ELEMENT BLOCK END ##############


//######### APPLYING EMR FOCUS CLASS TO ELEMENT BLOCK START ##############
//*******PURPOSE:  this method is used to applying emr focus class to element when required. applying class on focusing element and removing class on leave of element
//*******CREATED BY: George D
//*******CREATED DATE: 02/20/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Admin').directive('emrAnchorFocusClass', function () {
    return ({
        restrict: 'A',
        link: function (scope, element) {
            element.focus(function () {
                element.addClass('label label-info');
            });
            element.blur(function () {
                element.removeClass('label label-info');
            });
        },
    });
});
//######### APPLYING EMR FOCUS CLASS TO ELEMENT BLOCK END ##############


///////////////BUSY LOADER START////////////////////////
//http://blogs.msmvps.com/theproblemsolver/2014/03/28/adding-an-angularjs-ajax-busy-indicator-to-the-raw-stack/

//this directive is useful in showing the asynchronous busy indicator for the REST methods
angular.module('EMR.Admin').directive("rawAjaxBusyIndicator", function () {
    return ({
        link: function (scope, element) {
            scope.$on("ajax-start", function (event, actionType) {

                element.removeClass().addClass("busyLoading").html('<img src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader" />');

                element.show();
            });
            scope.$on("ajax-stop", function () {
                //$(".busyLoading-holder").hide();
                element.removeClass();
                element.hide();
            });
        }
    });
});

//######### BUSY LOADING INDICATOR BLOCK START ##############
//*******PURPOSE:  this Directive is Useful in showing the busy Indicator for Synchronous requests
//*******CREATED BY: MAHESH P
//*******CREATED DATE: 04/02/2016
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
///this Directive is Useful in showing the busy Indicator for Synchronous requests
angular.module('EMR.Admin').directive("rawAjaxSyncBusyIndicator", function () {
    return ({
        link: function (scope, element) {

            scope.$on("ajax-start-sync", function (event, args) {
                //$(".busyLoading-holder").show();
                //if current action type is save,update,delete (any action SP)
                //then we need to show the busy loading with back drop

                //defaults
                var actionType = adminWCFActionCallType.GETLIST;
                var actionMessage = "Loading data.. Please wait..";

                //MODIFIED BY MAHESH P ON 07/01/2016 FOR SUPPORTING THE CUSTOM MESSAGES WHILE CALLING THE SERVICES 
                //SENDING THE ACTION MESSAGE WHEN EXISTS ONLY OTHERWISE NOTHING
                //WHEN THE RECIEVED ARGUMENTS ARE OF THE OBJECT TYPE THEN ASSIGNING THE IT'S RESPECTIVE TYPE OF ACTION
                if (angular.isObject(args)) {

                    if (hasValue(args.ActionType))
                        actionType = args.ActionType;

                    if (hasValue(args.ActionMessage))
                        actionMessage = args.ActionMessage;
                }
                    //WHEN NOT AN OBJECT THEN IT IS IS DEFAULT ACTION MESSAGE
                else {
                    actionType = args;
                }
                //MODIFIED BY MAHESH P ON 07/01/2016 FOR SUPPORTING THE CUSTOM MESSAGES WHILE CALLING THE SERVICES 

                if (hasValue(actionType) && actionType == adminWCFActionCallType.INSERTUPDATEDELETE) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #ffffff;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div style="color:blue">Saving data.. Please wait..</div></div>');;
                }
                else if (hasValue(actionType) && actionType == adminWCFActionCallType.GETLIST) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #ffffff;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div style="color:blue">Loading data.. Please wait..</div></div>');;
                }
                else if (hasValue(actionType) && actionType == adminWCFActionCallType.EMRPRINT) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #ffffff;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div style="color:blue">Printing In Progress.. Please wait..</div></div>');;
                }

                else if (hasValue(actionType) && actionType == adminWCFActionCallType.EHRCUSTOM) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #ffffff;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div class="actionmsgtodisplay"><div style="color:blue">' + actionMessage + '</div></div></div>');;
                }
                else if (hasValue(actionType) && actionType == adminWCFActionCallType.SHOWPROGRESS) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #ffffff;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div class="actionmsgtodisplay" data-progressuid="' + args.uid + '">' + actionMessage + '</div></div>');;
                }     
                else if (hasValue(actionType) && actionType == adminWCFActionCallType.EHRDOCUMENT) {
                    element.removeClass().addClass("busyLoadingWithBackDrop").html('<div style="width: 250px; height: 75px; text-align: center; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto; font-size: 16px; z-index: 10; color: #0000FF;"><img width="60px" height="60px" src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader"><div style="color:blue">Processing your document… Please wait.</div></div>');
                }          
                else
                    element.removeClass().addClass("busyLoading").html('<img src="UITheme/images/emrBusyLoader.gif" alt="Busy Loader" />');


                element.show();
            });
            scope.$on("ajax-stop-sync", function () {
                //$(".busyLoading-holder").hide();
                element.removeClass();
                element.hide();
            });
        }
    });
});

///this config is for showing the busy cursor in the browser panel when a http request is made 
EMRAdmin.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push("myHttpInterceptor");//pushing the factory as function for observing the request, response, response error of every http call in network
}]).factory("myHttpInterceptor", ["$q", "$window", "$rootScope", "$timeout", "$injector", function ($q, $window, $rootScope, $timeout, $injector) {

    var httpRequests = 0;
    var httpSyncRequests = 0;
    let idleTimeoutPromise = null;
    let $http;

    ///**
    // * Main object
    // */
    //var _lb = {}

    ////Default loading bar position
    //_lb.position = 'top';
    //_lb.direction = 'width'

    //THESE EVENTS ARE ONLY FOR SYNCHRONOUS REQUESTS AND THESE CAN BE USED FROM ANY OF THE CONTROLLERS
    $rootScope.$on("ajax-loader-countincrement", function (event, args) {
        if (hasValue(args)) {
            if (angular.isNumber(args))
                showBusyIndicator(args);
            else if (angular.isObject(args)) {
                showBusyIndicator(args.actiontype, args.actionMessage, args.WCFRequestGUID);//args.WCFRequestGUID//ADDED BY PHANI KUMAR M ON 18 TH JULY 2018
            }
            else
                showBusyIndicator(args);
        }

        else
            showBusyIndicator(adminWCFActionCallType.GETLIST);
    });

    //THIS EVENT IS USEFUL IN STOPPING THE BUSY INDICATOR
    $rootScope.$on("ajax-loader-countdecrement", function (event, args) {

        if (hasValue(args))
            hideBusyIndicator(args);
        else
            hideBusyIndicator(adminWCFActionCallType.GETLIST);
    });
    //THESE EVENTS ARE ONLY FOR SYNCHRONOUS REQUESTS AND THESE CAN BE USED FROM ANY OF THE CONTROLLERS


    //if current action type is save,update,delete (any action SP)
    //then we need to show the busy loading with back drop
    function showBusyIndicator(ehrAdminCurrentCallingActionType, ehrAdminCurrentCallingActionMessage, uid) {

        //when there exists action type for the request then it is synchronous request so showing that type pf busy indicator
        if (hasValue(ehrAdminCurrentCallingActionType) && ehrAdminCurrentCallingActionType != adminWCFActionCallType.ASYNCHRONOUS) {
            if (!httpSyncRequests) {

                var args = {
                    ActionType: ehrAdminCurrentCallingActionType,
                    uid: uid
                };

                //MODIFIED BY MAHESH P ON 07/01/2016 FOR SUPPORTING THE CUSTOM MESSAGES WHILE CALLING THE SERVICES 
                //SENDING THE ACTION MESSAGE WHEN EXISTS ONLY OTHERWISE NOTHING
                if (hasValue(ehrAdminCurrentCallingActionMessage))
                    args.ActionMessage = ehrAdminCurrentCallingActionMessage;

                $rootScope.$broadcast("ajax-start-sync", args);
            }
            httpSyncRequests++;
            startIdleTimer(); 
        }
        else {

            if (!httpRequests) {
                $rootScope.$broadcast("ajax-start");
            }
            httpRequests++;
        }

    }

    //hide the busy indicator based on the request type
    function hideBusyIndicator(ehrCurrentCallingActionType) {

        //when there exists action type for the request then it is synchronous request so showing that type pf busy indicator
        if (hasValue(ehrCurrentCallingActionType) && ehrCurrentCallingActionType != adminWCFActionCallType.ASYNCHRONOUS) {
         
            httpSyncRequests--;
            if (httpSyncRequests < 0)
                httpSyncRequests = 0;
            if (!httpSyncRequests) {
                $rootScope.$broadcast("ajax-stop-sync", ehrCurrentCallingActionType);
            }
            
        }
        else {
            httpRequests--;
            if (httpRequests < 0)
                httpRequests = 0;
            if (!httpRequests) {
                $rootScope.$broadcast("ajax-stop");
            }
        }

    }
    function startIdleTimer() {
        // cancel existing timeout if any
        if (idleTimeoutPromise) {
            $timeout.cancel(idleTimeoutPromise);
        }
        if (!$http)
            $http = $injector.get('$http');
        // start new timeout (65 seconds = 65000 ms)
        idleTimeoutPromise = $timeout(function () {
            //if any api is specifically designed to show loader greater than 60 seconds then we run it on 1 min loop
            if (_.find($http.pendingRequests, function (eachrequest) { return eachrequest.data && eachrequest.data.ehrAdminCurrentCallingActionType && eachrequest.data.ehrAdminCurrentCallingActionType != adminWCFActionCallType.ASYNCHRONOUS }))
                return startIdleTimer();

            // if no api requests and count is greater than one even after one min then its most likely javascript code issue so clearing the loader
            if (httpSyncRequests > 0) {
                httpSyncRequests = 0;
                $rootScope.$broadcast("ajax-stop-sync");
            } 
            console.log(`%c Pending Ajax Loader Requests Count ${httpSyncRequests}`, "color: blue; font-size: 10px; font-weight: bold;");
        }, 65000, false);
    }

    return {
        //request initiated
        'request': function (config) {

            if (hasValue(config) && hasValue(config.data) && hasValue(config.data.ehrAdminCurrentCallingActionType)) {

                //if (config.data.ehrAdminCurrentCallingActionType == adminWCFActionCallType.SHOWPROGRESS) {
                //	/**
                //	 * Random loading bar initial percentage
                //	 */
                //	_lb.percentage = Math.random() + 10;
                //	//$("#loading-bar")[_lb.direction](_lb.percentage + "%");

                //	/**
                //	 * Bump loading percentage between current and 99%
                //	 */
                //	_lb.interval = setInterval(function () {

                //		_lb.percentage = Math.random() * ((100 - _lb.percentage) / 4) + _lb.percentage;

                //		//$("#loading-bar")[_lb.direction](_lb.percentage + "%");

                //		// showBusyIndicator(adminWCFActionCallType.EHRCUSTOM, "Completed " + _lb.percentage + "%");

                //		angular.element('.busyLoadingWithBackDrop').find('.actionmsgtodisplay').html("Completed " + parseInt(_lb.percentage) + "%");

                //	}, 250);

                //	showBusyIndicator(adminWCFActionCallType.EHRCUSTOM, "Completed " + parseInt(_lb.percentage) + "%");
                //}

                //else {

                if (config.data.ehrAdminCurrentCallingActionType == adminWCFActionCallType.SHOWPROGRESS) {
                    showBusyIndicator(config.data.ehrAdminCurrentCallingActionType, config.data.ehrAdminCurrentCallingMessage, config.data.WCFRequestGUID);
                }
                else {
                    if (hasValue(config.data.ehrAdminCurrentCallingMessage))
                        showBusyIndicator(config.data.ehrAdminCurrentCallingActionType, config.data.ehrAdminCurrentCallingMessage);
                    else
                        showBusyIndicator(config.data.ehrAdminCurrentCallingActionType);
                }
                //}
                //config.data.ehrAdminCurrentCallingActionType = undefined;
            }
            else
                showBusyIndicator();

            return $q.when(config);

        }, 'response': function (response) {

            if (hasValue(response) && hasValue(response.config) && hasValue(response.config.data) && hasValue(response.config.data.ehrAdminCurrentCallingActionType)) {
                //if (response.config.data.ehrAdminCurrentCallingActionType == adminWCFActionCallType.SHOWPROGRESS) {
                //	angular.element('.busyLoadingWithBackDrop').find('.actionmsgtodisplay').html("Completed " + "100" + "%");
                //	clearInterval(_lb.interval);
                //}

                hideBusyIndicator(response.config.data.ehrAdminCurrentCallingActionType);
            }
            else {
                hideBusyIndicator();
            }
            return $q.when(response);

        }, 'responseError': function (rejection, d, a, c) {


            //the following lines are added for offline support of unhandling the preventions
            //when it is HTML Page Request For Opening the Popup or any main view
            if (hasValue(rejection) && hasValue(rejection.config) && hasValue(rejection.config.url) && rejection.config.url.toString().indexOf("EMRWEB") >= 0 && rejection.config.url.toString().indexOf(".html") >= 0
				&& (rejection.status == 0) && rejection.statusText == "") {

                //when there is no popup is opened then
                if ($("body").hasClass("modal-open")) {

                    $timeout(function () {

                        //when a popup is opened accidenally and internet is not connected then only going to do this
                        if ($("body").hasClass("modal-open") && $rootScope.ehrisApplicationOnline == false) {
                            //when there is any opened popup then closing all the popups
                            if ($("[uib-modal-backdrop]").length == 1) {
                                $("[uib-modal-backdrop]").remove();
                            }
                            if ($("[modal-window]").length == 1) {
                                $("[modal-window]").remove();
                            }

                        }
                    }, 1000);

                }
            }

            if (hasValue(rejection) && hasValue(rejection.config) && hasValue(rejection.config.data) && hasValue(rejection.config.data.ehrAdminCurrentCallingActionType)) {

                //if (rejection.config.data.ehrAdminCurrentCallingActionType == adminWCFActionCallType.SHOWPROGRESS) {
                //	angular.element('.busyLoadingWithBackDrop').find('.actionmsgtodisplay').html("Completed " + "100" + "%");
                //	clearInterval(_lb.interval);
                //}

                hideBusyIndicator(rejection.config.data.ehrAdminCurrentCallingActionType);
            }
            else {
                hideBusyIndicator();
            }
            return $q.reject(rejection);
        }
    };
}]);
//######### BUSY LOADING INDICATOR BLOCK START ##############




//written by mahesh p  03/10/2015
//this method is useful in listening to the n/w connections status 
EMRAdmin.run(['$window', '$rootScope', "$document", "LoginService", function ($window, $rootScope, $document, LoginService) {
    $rootScope.ehrisApplicationOnline = navigator.onLine;
    $window.addEventListener("offline", function () {

        angular.element(".ehrofflinestatus").css({ "display": "block" });

        if (angular.element(".ehrofflinestatus").length <= 0) {
            var offlineStatusHTML = '<div class="ehrofflinestatus offline-ui offline-ui-down offline-ui-waiting"><div class="offline-ui-content"></div></div>';
            //$document.appendChild(offlineStatusHTML);
            $("body").append(offlineStatusHTML);
        }

        console.log('offline');
        EHRISInternetAvailaible = false;
        $rootScope.$apply(function () {
            $rootScope.ehrisApplicationOnline = false;
        });
    }, false);
    $window.addEventListener("online", function () {
        console.log('online');
        angular.element(".ehrofflinestatus").css({ "display": "none" });

        EHRISInternetAvailaible = true;
        
        $rootScope.$apply(function () {
            $rootScope.ehrisApplicationOnline = true;
        });
    }, false);
}]);



//written by mahesh p  07/29/2015
//usage : <any emr-compile-html="htmlstring" ></any>
//this directive is useful in compile the given html string with the given clicks and all and then binding to the respected element
angular.module('EMR.Admin').directive('emrCompileHtml', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
			function (scope) {
			    return scope.$eval(attrs.emrCompileHtml);
			},
			function (value) {
			    element.html(value);
			    $compile(element.contents())(scope);
			}
		)
    };
}])

// using this directive To avoid this error [ngModel:numfmt] Expected `1` to be a number angularjs
// usage : <any string-to-number="2" ></any>
// Written By Pavan B at 09/08/2018
// under the guidance of Uday V 
angular.module('EMR.Admin').directive('stringToNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                return '' + value;
            });
            ngModel.$formatters.push(function (value) {
                return parseInt(value);
            });
        }
    };
});


//EMRAdmin.config(['$httpProvider', function ($httpProvider) {


//    $httpProvider.interceptors.push(function ($q, $rootScope) {
//        var requests = 0;

//        function show() {
//            if (!requests) {
//                $rootScope.$broadcast("ajax-start");
//            }
//            requests++;
//        }

//        function hide() {
//            requests--;
//            if (!requests) {
//                $rootScope.$broadcast("ajax-stop");
//            }
//        }

//        return {
//            'request': function (config) {
//                show();
//                return $q.when(config);
//            }, 'response': function (response) {
//                hide();
//                return $q.when(response);
//            }, 'responseError': function (rejection) {
//                hide();
//                return $q.reject(rejection);
//            }
//        };
//    });
//}]);

///////////////BUSY LOADER END////////////////////////


//added by balakrishna.D on 08/01/2015 for getting the unique values from the array
EMRAdmin.filter('unique', function () {
    return function (collection, keyname) {
        var output = [],
			keys = [];

        angular.forEach(collection, function (item) {
            var key = item[keyname];
            if (keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
            }
        });
        return output;
    };
});


//this is the template cache for the emr common Information Message
EMRAdmin.run(['$templateCache', function ($templateCache) {
    $templateCache.put('EMRCommonInfoMessage.html', '<div id="wrapper"><div class="emr_info entypo-info2" style="font-size: 20px;top:150px;text-align:center;margin-top:220px;">  {{commonInformationMessage}} </div></div>');
}]);

///this directive is useful in generating the information message when user wants to give/show the information message
/// In HTML :  <div id="divHtmlTemplatesInfoMessage_{{htmlTemplatesFormGuid}}" emr-common-info-message ng-show="htmlTemplatesShowInfoMessage" options="htmlTemplatesCommonInfoPageOptions"></div>
/// in Controller :              $scope.htmlTemplatesCommonInfoPageOptions = {InformationMessageToDisPlay: "You are Unauthorized to Create Easy Forms."};

angular.module('EMR.Admin').directive('emrCommonInfoMessage', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'EMRCommonInfoMessage.html',
        scope: {
            emrCommonInfoOptions: '=options',//getting the options from the user
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

                if (hasValue(scope.emrCommonInfoOptions) && hasValue(scope.emrCommonInfoOptions.InformationMessageToDisPlay)) {
                    scope.commonInformationMessage = scope.emrCommonInfoOptions.InformationMessageToDisPlay;
                }
                else
                    scope.commonInformationMessage = "No Data Available";
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {


                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrCommonInfoOptions.InformationMessageToDisPlay', function () {
                    if (hasValue(scope.emrCommonInfoOptions) && hasValue(scope.emrCommonInfoOptions.InformationMessageToDisPlay))
                        scope.commonInformationMessage = scope.emrCommonInfoOptions.InformationMessageToDisPlay;
                    else
                        scope.commonInformationMessage = "No Data Available";
                });

                //iElement.on("$destroy", function () {
                //    unbindWatch();
                //    iElement.empty();
                //    iElement.remove();
                //});
            }
        }
    })
});



//this is the template cache for the emr common Information Message
EMRAdmin.run(['$templateCache', function ($templateCache) {
    //$templateCache.put('EMRCommonInfoMessagePersmissions.html', '<div id="wrapper"><div class="emr_info entypo-info2" style="font-size: 20px;top:150px;text-align:center;margin-top:220px;">  {{commonInformationMessage}} </div></div>');


    $templateCache.put('EMRCommonInfoMessagePersmissions.html', '<div><div class="emr_info" style="cursor: default; text-align: center; margin-top: 120px">' +
		'<span class="entypo-info2" style="vertical-align: middle; padding-right: 5px; font-size: 30px;"></span>' +
		'<label style="font-size: 20px; word-spacing: 3px; cursor: default; text-align: center; font-weight: 100; margin-bottom: 0px; font-family: initial;" ng-bind="commonInformationMessage"></label>' +
		'</div>' +
		'<div style="cursor: default; text-align: center; margin-bottom: 120px">' +
		'<button class="btn btn-default" tabindex="21915" style="width:70px;" ng-enter="$parent.Cancel();" ng-click="$parent.Cancel();">Cancel</button>' +
		'</div></div>');
}]);

///this directive is useful in generating the information message when user wants to give/show the information message
/// In HTML :  <div id="divHtmlTemplatesInfoMessage_{{htmlTemplatesFormGuid}}" emr-common-info-message ng-show="htmlTemplatesShowInfoMessage" options="htmlTemplatesCommonInfoPageOptions"></div>
/// in Controller :              $scope.htmlTemplatesCommonInfoPageOptions = {InformationMessageToDisPlay: "You are Unauthorized to Create Easy Forms."};

angular.module('EMR.Admin').directive('emrCommonInfoMessagePermissions', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'EMRCommonInfoMessagePersmissions.html',
        scope: {
            emrCommonInfoOptions: '=options',//getting the options from the user
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

                scope.commonInformationMessage = EmrPermissionShowingMessage;

                if (hasValue(scope.emrCommonInfoOptions) && hasValue(scope.emrCommonInfoOptions.InformationMessageToDisPlay)) {
                    scope.commonInformationMessage = scope.emrCommonInfoOptions.InformationMessageToDisPlay;
                }
                else
                    scope.commonInformationMessage = EmrPermissionShowingMessage;
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {


                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrCommonInfoOptions.InformationMessageToDisPlay', function () {
                    if (hasValue(scope.emrCommonInfoOptions) && hasValue(scope.emrCommonInfoOptions.InformationMessageToDisPlay))
                        scope.commonInformationMessage = scope.emrCommonInfoOptions.InformationMessageToDisPlay;
                    else
                        scope.commonInformationMessage = EmrPermissionShowingMessage;
                });

                //iElement.on("$destroy", function () {
                //    unbindWatch();
                //    iElement.empty();
                //    iElement.remove();
                //});
            }
        }
    })
});


//this directive is useful in changing the display sequence of the form elements as per the given input JSON Object
angular.module('EMR.Admin').directive('emrDisplaySequenceOrder', function () {
    return ({
        scope: {
            emrDisplaySequenceOrderOptions: '=options',//getting the options from the user
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {

                //watching if the data source has changed or not , 
                var unbindWatch = scope.$watch('emrDisplaySequenceOrderOptions', function () {
                    scope.reassingData();
                });

                scope.reassingData = function () {
                    var data = [
						{
						    Field: "isipa",
						    DisplaySequence: 25
						},
						{
						    Field: "usefor",
						    DisplaySequence: 3
						},
						{
						    Field: "originalhealthplanname",
						    DisplaySequence: 6
						},
						{
						    Field: "healthplanabbreviation",
						    DisplaySequence: 7
						},
						{
						    Field: "healthplanabbreviation",
						    DisplaySequence: 8
						},
						{
						    Field: "physiciangroup",
						    DisplaySequence: 1
						},
						{
						    Field: "physiciangroupshortname",
						    DisplaySequence: 9
						},


                    ];

                    data.sortByKey('DisplaySequence');

                    if (hasValue(data) && angular.isArray(data)) {

                        //data = scope.emrDisplaySequenceOrderOptions;

                        var formId = iElement.parents('form').attr("id");

                        if (hasValue(angular.element("#styleForCurrentForm" + formId)) && angular.element("#styleForCurrentForm" + formId).length > 0) {
                            angular.element("#styleForCurrentForm" + formId).remove();
                        }


                        //var styleToBind = "<style id='styleForCurrentForm" + formId + "'>";

                        //styleToBind = styleToBind + "#" + formId + "{ display:flex;flex-flow: column;}";


                        //angular.forEach(data, function (item, index) {
                        //    if (hasValue(item.Field))
                        //        styleToBind = styleToBind + "[" + item.Field.toLowerCase() + "]{order:" + (index + 1) + ";}";

                        //});

                        //styleToBind += "</style>";


                        var styleToBind = "<style id='styleForCurrentForm" + formId + "'>" + "#" + formId + "{display: -webkit-box;display: -moz-box;display: box;-webkit-box-orient: vertical;-moz-box-orient: vertical;box-orient: vertical;}";

                        angular.forEach(data, function (item, index) {
                            if (hasValue(item.Field))
                                styleToBind = styleToBind + "[" + item.Field.toLowerCase() + "]{ -webkit-box-ordinal-group: " + (index + 1) + "; -moz-box-ordinal-group: " + (index + 1) + "; box-ordinal-group: " + (index + 1) + ";}";

                        });

                        styleToBind += "</style>";

                        $("#" + formId).prepend(styleToBind);
                    }





                };

                scope.reassingData();

                //on destroy event of the element from the DOM
                iElement.on("$destroy", function () {
                    unbindWatch();

                });

            }
        }
    })
});


//example HTML usage: emr-short-cut-key options="alt+ctrl+shift+51"
angular.module('EMR.Admin').directive('emrShortCutKeyss', ['$document', function ($document) {
    return ({
        restrict: 'AE',
        //transclude: true,
        ////replace: true,
        //scope: {
        //    //emrShortCutKeyOptions: '=options',//getting the options from the user
        //},
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {

            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {

                scope.fieldRaiseShortCutKey = function (event) {

                    if (hasValue(event) && hasValue(event.stringFormatted)) {

                        if (event.stringFormatted.toLowerCase() == iAttrs.options.toLowerCase()) {


                            scope.$apply(function () {
                                scope.$eval(iAttrs.ngEnter);
                            });

                            //focusing the current element
                            iElement.focus();

                            event.preventDefault();
                        }

                    }

                };

                //watching if the data source has changed or not , 

                if (hasValue(iAttrs.options)) {

                    scope.currentKeyDownGUID = adminGetGUID();

                    $document.bind('keydown.' + scope.currentKeyDownGUID, function (event) {

                        // if (event.target.tagName.toLowerCase() == "body") {
                        //16: 'shift', 17: 'ctrl', 18: 'alt',
                        if (event.keyCode != 18 && event.keyCode != 16 && event.keyCode != 17) {
                            if (event.altKey && event.ctrlKey && event.shiftKey) {
                                event.stringFormatted = "alt+ctrl+shift+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.altKey && event.ctrlKey) {
                                event.stringFormatted = "alt+ctrl+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.altKey && event.shiftKey) {
                                event.stringFormatted = "alt+shift+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.ctrlKey && event.shiftKey) {
                                event.stringFormatted = "ctrl+shift+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.altKey) {
                                event.stringFormatted = "alt+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.ctrlKey) {
                                event.stringFormatted = "ctrl+" + String.fromCharCode(event.keyCode)
                                scope.fieldRaiseShortCutKey(event);
                            }
                            else if (event.shiftKey) {
                                event.stringFormatted = "shift+" + String.fromCharCode(event.keyCode);
                                scope.fieldRaiseShortCutKey(event);
                            }
                        }
                        // console.log(event);

                    });

                }

                //on destroy event of the element from the DOM
                iElement.on("$destroy", function () {
                    $document.unbind('keydown.' + scope.currentKeyDownGUID);
                    //$document.unbind('keypress.' + scope.currentKeyDownGUID);
                });


            }
        }
    })
}]);

//######### UNSAFE FILTER BLOCK START #############
///*******PURPOSE: THIS FILTER IS USED TO APPLY STRING TO TRUST AS HTML
///*******CREATED BY: ABDUL RAHIMAN M
///*******CREATED DATE: 4/16/2016
///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************

EMRAdmin.filter('unsafe', function ($sce) { return $sce.trustAsHtml; });

//######### UNSAFE FILTER BLOCK ENDS #############




//######### MULTI COLUMN LIST VIEW BLOCK START #############
///*******PURPOSE: THIS FILTER IS USED TO APPLY STRING TO TRUST AS HTML
///*******CREATED BY: MAHESH P
///*******CREATED DATE: 06/27/2016
///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
//this is the template cache for the emr multi column list
EMRAdmin.run(['$templateCache', function ($templateCache) {
    $templateCache.put('EMRMultiColumnListViewVertical.html', '<div><style> .EMRMultiColumnListViewVertical ul li { width:125px; overflow-x:hidden; text-overflow:ellipsis; white-space:pre;} .EMRMultiColumnListViewVertical ul { margin: 0;padding: 0; list-style-type: none !important; text-align: left; float: left; position: relative; margin-right: 10px;}</style>' +
		'<div class="EMRMultiColumnListViewVertical"><ul><li data-uid="item_{{$index+1}}" ng-repeat="item in EMRMultiColumnLisOptions.dataSource">'
		+ '<input type="checkbox" style="vertical-align: text-bottom;" ng-model="item.selected" ng-click="toggleSelect(this.item,$index,$event)" id="chkBox{{$index}}"/><label style="padding-left: 5px;" for="chkBox{{$index}}">{{item[EMRMultiColumnLisOptions.columns[0].field]}}</label></li></ul></div>');
}]);

///this directive is useful in generating the multi columns checkbox list for the given data source
/// In HTML :  <div emr-multi-column-list options="listOptions"></div>
/// in Controller :  $scope.listOptions={dataSource : $scope.jsonListToBind,columns:[field : "field To Display"],multiselect : false ,columnsCount: 4,selectedItems : $scope.listOfSelectedItems//for getting the selected or checked items };

angular.module('EMR.Admin').directive('emrMultiColumnListVertical', function () {
    return ({
        restrict: 'AE',
        transclude: true,
        replace: true,
        templateUrl: 'EMRMultiColumnListViewVertical.html',
        scope: {
            EMRMultiColumnLisOptions: '=options',//getting the options from the user
        },
        link: {
            //this method executes when the link function has started
            pre: function preLink(scope, iElement, iAttrs, controller) {
                var strCount = scope.EMRMultiColumnLisOptions.columnsCount.toString();//converting the int count value to string
                iElement.css({ "-moz-column-count": strCount, "-webkit-column-count": strCount, "column-count": strCount });//applying the no.of columns count as the user specified to display in the no.of columns
            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink(scope, iElement, iAttrs, controller) {

                //this method is useful in making the single select columns                           
                scope.toggleSelect = function (itemSelected, ind, event) {
                    //single select case if the multi select is not specifieed
                    if (!scope.EMRMultiColumnLisOptions.multiselect || scope.EMRMultiColumnLisOptions.multiselect == undefined) {
                        scope.EMRMultiColumnLisOptions.selectedItems = [itemSelected];//pushing into selection array for maintaining the selected items
                        //this method is fired when the user has clicked on the checkbox or it's respected label
                        iElement.find("input[type='checkbox']").click(function () {
                            iElement.find("input[type='checkbox']").not(this).removeAttr("checked");//removing the checked for all except the selected or clicked
                        });
                    }
                        //in case of multi select
                    else {
                        //the user can get this array at controller side for getting the selected items in the list
                        scope.EMRMultiColumnLisOptions.selectedItems.unshift(itemSelected);//pushing into selection array for maintaining the selected items 
                    }
                };


                //this method is useful in making the single select columns                           
                scope.EMRMultiColumnLisOptions.getSelectedItemsFromList = function () {
                    scope.EMRMultiColumnLisOptions.selectedItems = [];


                    iElement.find("input[type='checkbox']:checked").forEach(function (itemElement) {
                        scope.EMRMultiColumnLisOptions.selectedItems.push(angular.element(itemElement)(scope))
                    })
                    return scope.EMRMultiColumnLisOptions.selectedItems;

                };




            }
        }
    })
});


////example
//angular.module('EMR.Admin').controller('MyCtrl', function ($scope) {

//    $scope.jsonListToBind = [{ "PatientStatus": "Active" }, { "PatientStatus": "Active2" },
//    { "PatientStatus": "Active3" }, { "PatientStatus": "Active4" },
//    { "PatientStatus": "Active5" }, { "PatientStatus": "Active6" }, { "PatientStatus": "Active7" }, { "PatientStatus": "Active8" }, { "PatientStatus": "Active9" }, { "PatientStatus": "Active10" }, { "PatientStatus": "Active11" }, { "PatientStatus": "Active12" }, { "PatientStatus": "Active13" }, { "PatientStatus": "Active14" }, { "PatientStatus": "Active15" }, { "PatientStatus": "Active16" }, { "PatientStatus": "Active17" }, { "PatientStatus": "Active18" }, { "PatientStatus": "Active19" }, { "PatientStatus": "Active20" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, , { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }, { "PatientStatus": "Active" }

//    ]
//    $scope.listOfSelectedItems = [];

//    $scope.dataoptions = {
//        dataSource: $scope.jsonListToBind,
//        columns: [{ field: "PatientStatus" }],
//        multiselect: true, columnsCount: 6, selectedItems: $scope.listOfSelectedItems
//    };
//});
//######### MULTI COLUMN LIST VIEW BLOCK END #############








//infinite-scroll-table="applyPaymentsAddMoreItems()" infinite-scroll-distance="2"
angular.module('EMR.Admin').directive('infiniteScrollTable', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
    return {
        link: function (scope, elem, attrs) {

            var checkWhenEnabled, handler, scrollDistance, scrollEnabled;

            $window = angular.element($window);
            elem.css('overflow-y', 'scroll');
            elem.css('overflow-x', 'auto');
            elem.css('height', 'inherit');
            scrollDistance = 0;

            //Assign Scroll Distance when it changed
            if (attrs.infiniteScrollDistance != null) {
                scope.$watch(attrs.infiniteScrollDistance, function (value) {
                    return scrollDistance = parseInt(value, 10);
                });
            }

            scrollEnabled = true;
            checkWhenEnabled = false;

            if (attrs.infiniteScrollDisabled != null) {
                scope.$watch(attrs.infiniteScrollDisabled, function (value) {
                    scrollEnabled = !value;
                    if (scrollEnabled && checkWhenEnabled) {
                        checkWhenEnabled = false;
                        return handler();
                    }
                });
            }


            //$rootScope.$on('refreshStart', function (event, parameters) {
            //    elem.animate({ scrollTop: "0" });
            //});

            //HANDLER TO HANDLE THE SCROLL EVENT FOR LAZY RENDERING
            handler = function () {
                var container, elementBottom = 0, remaining, shouldScroll, containerBottom = 0;

                container = $(elem.children()[0]);

                if (hasValue(elem.offset()))
                    elementBottom = elem.offset().top + elem.height();

                if (hasValue(container.offset()))
                    containerBottom = container.offset().top + container.height();

                remaining = containerBottom - elementBottom;
                shouldScroll = remaining <= elem.height() * scrollDistance;

                if (shouldScroll && scrollEnabled) {
                    if ($rootScope.$$phase) {
                        return scope.$eval(attrs.infiniteScrollTable);
                    } else {
                        return scope.$apply(attrs.infiniteScrollTable);
                    }
                } else if (shouldScroll) {
                    return checkWhenEnabled = true;
                }
            };

            elem.on('scroll.test', handler);
            scope.$on('$destroy', function () {
                return $window.off('scroll', handler);
            });
            return $timeout((function () {
                if (attrs.infiniteScrollImmediateCheck) {
                    if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                        return handler();
                    }
                } else {
                    return handler();
                }
            }), 0);
        }
    };
}
]);


///*******PURPOSE: This is used to get currency format string of given amount. Especially Returns -ve amount like ($12.00) as -$12.00
//*******CREATED BY: KranthiG
//*******CREATED DATE: DEC 09 2016
EMRAdmin.filter('currencyEMR', ['$filter', function ($filter) {

    return function (amount, symbol, fractionSize) {

        var output = "";//, symbol = "$";
        if (!hasValue(symbol))
            symbol = "$";

        if (hasValue(amount)) {

            output = hasValue(fractionSize) ? $filter('currency')(amount, symbol, fractionSize) : $filter('currency')(amount, symbol);

            if (amount < 0) output = output.replace(')', '').replace('(', '-');
        }

        return output;
    };
}]);





//<search-patient-field filter-on="1" ng-model="incomingReferralFormat2MainViewClientFirstName" model="incomingReferralFormat2MainViewClientFirstName" option-enter="incomingReferralFormat2MainViewRefreshMainGridData(true, undefined);" focus-me="incomingFocusme"></search-patient-field>
///filter-on="1" // 1 -- first name , 2 -- LastName, 3 -- PatientFullName
angular.module('EMR.Admin').directive('searchPatientField', ['$rootScope', '$window', 'bedCensusService', '$parse', '$timeout', function ($rootScope, $window, bedCensusService, $parse, $timeout) {
    return {
        require: 'ngModel',
        restrict: 'AE',
        transclude: true,
        template: '<input kendo-auto-complete="nameSearchFieldOptionWidgets" ng-blur="nameSearchFieldBlur()" ng-model="nameSearchField" k-options="nameSearchFieldOption" ng-enter="nameSearchFieldOnEnter();" style="width: 100%;" />',
        scope: {
            optionModel: "=model",
            optionEnter: '&optionEnter',
            focusMeOption: "=focusMe"
        },
        link: function ($scope, $elem, $attrs, modelCtrl) {

            var filterOn = $attrs.filterOn; var unbindWatch, unbindWatchOnUsersName;
            var dataItemField = (filterOn == 1 ? "FirstName" : (filterOn == 2 ? "LastName" : (filterOn == 3 ? "PatientFullName" : "LastName")));


            //if (hasValue($attrs.focusMe)) {

            //var modelFocus = $parse($attrs.focusMe);

            unbindWatch = $scope.$watch('vm.focusMeOption', function (value) {
                //console.log('value=', value);
                if (value === true) {
                    $timeout(function () {
                        if ($(window).width() > 1024) {
                            if (hasValue($scope.nameSearchFieldOptionWidgets))
                                $scope.nameSearchFieldOptionWidgets.focus();
                        }
                    }, 200);
                }
            });


            unbindWatchOnUsersName = $scope.$watch('vm.optionModel', function (newValue, oldValue) {

                if (newValue != oldValue) {
                    if (!$scope.isScriptRendering) {
                        $scope.nameSearchField = newValue;
                        $scope.firstNameSearchFieldOptionsDataSource.read();
                    }
                }
            });

            $scope.nameSearchFieldBlur = function () {
                //if (hasValue($attrs.focusMe)) {
                //var modelFocus = $parse($attrs.focusMe);
                //$scope.$apply(focusMeOption.assign($scope, false));

                $scope.vm.focusMeOption = false;

                $scope.$apply();
                //}
            };



            if (filterOn == 1) {
                var schemaModel = {
                    LastName: function (data) {
                        return data.LastName;
                    },
                };

            }
            else if (filterOn == 2) {
                var schemaModel = {
                    FirstName: function (data) {
                        return data.FirstName;
                    },
                };
            }
            else if (filterOn == 3) {
                var schemaModel = {
                    PatientFullName: function (data) {
                        return data.PatientFullName;
                    }
                };
            }

            $scope.firstNameSearchFieldOptionsDataSource = new kendo.data.DataSource({
                data: [],
                serverFiltering: true,
                transport: {
                    read: function (options) {

                        if (filterOn == 1) {
                            var postData = {
                                "FirstName": $scope.nameSearchField,
                            };
                        }
                        else if (filterOn == 2) {
                            var postData = {
                                "LastName": $scope.nameSearchField,
                            };
                        }
                        else if (filterOn == 3) {
                            var postData = {
                                "PatientFullName": $scope.nameSearchField,
                            };
                        }
                        bedCensusService.inPatientGetPatientSearchList(postData).then(function (serviceResponse) {
                            if (isError(serviceResponse)) return false;
                            options.success(serviceResponse);
                        });
                    }
                },
                schema: schemaModel
            });


            $scope.nameSearchFieldOnEnter = function () {

                $scope.isScriptRendering = true;

                //var model = $parse($attrs.model);
                //$scope.$apply(model.assign($scope, $scope.nameSearchField));

                //var ngModelWatch = $parse($attrs.ngModel);
                //$scope.$apply(ngModelWatch.assign($scope, $scope.nameSearchField));


                //modelCtrl.$setViewValue($scope.nameSearchField);
                //modelCtrl.$render();


                $scope.vm.optionModel = $scope.nameSearchField;


                $scope.$apply();

                $scope.optionEnter();

                $scope.isScriptRendering = false;
            };


            $scope.nameSearchFieldOption = {
                dataSource: $scope.firstNameSearchFieldOptionsDataSource,
                dataTextField: dataItemField,
                filter: "contains",
                dataBound: function (kendoEvent) {
                    $scope.nameSearchFieldOptionWidgets = kendoEvent.sender;
                },
                change: function (kendoEvent) {
                    if (hasValue(this.dataItem(kendoEvent.item))) {
                        $scope.nameSearchField = this.dataItem(kendoEvent.item)[dataItemField];
                    } else {
                        $scope.nameSearchField = this.value();
                    }


                    $scope.nameSearchFieldOnEnter();
                },
                select: function (kendoEvent) {
                    if (hasValue(this.dataItem(kendoEvent.item))) {
                        $scope.nameSearchField = this.dataItem(kendoEvent.item)[dataItemField];
                    } else {
                        $scope.nameSearchField = this.value();
                    }


                    $scope.nameSearchFieldOnEnter();
                }
            };

            $elem.on('$destroy', function () {
                if (unbindWatch)
                    unbindWatch();//unbinding watch

                unbindWatchOnUsersName();
            });


        }
    }

}]);

///The following code inserted by Kranthi to handle on scrolling
angular.module('EMR.Admin').directive('infiniteScroll', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
    return {
        link: function (scope, elem, attrs) {

            var checkWhenEnabled, handler, scrollDistance, scrollEnabled;

            $window = angular.element($window);
            elem.css('overflow-y', 'scroll');
            elem.css('overflow-x', 'hidden');
            //elem.css('height', 'inherit');
            scrollDistance = 0;

            //Assign Scroll Distance when it changed
            if (attrs.infiniteScrollDistance != null) {
                scope.$watch(attrs.infiniteScrollDistance, function (value) {
                    return scrollDistance = parseInt(value, 10);
                });
            }

            scrollEnabled = true;
            checkWhenEnabled = false;

            //scroll desabled
            if (attrs.infiniteScrollDisabled != null) {
                scope.$watch(attrs.infiniteScrollDisabled, function (value) {
                    scrollEnabled = !value;
                    if (scrollEnabled && checkWhenEnabled) {
                        checkWhenEnabled = false;
                        return handler();
                    }
                });
            }


            //Reset Scroll height
            handler = function () {
                var container, elementBottom = 0, remaining, shouldScroll, containerBottom = 0;
                container = $(elem.children()[0]);
                if (hasValue(elem.offset()))
                    elementBottom = elem.offset().top + elem.height();
                if (hasValue(container.offset()))
                    containerBottom = container.offset().top + container.height();
                remaining = containerBottom - elementBottom;
                shouldScroll = remaining <= elem.height() * scrollDistance;
                if (shouldScroll && scrollEnabled) {
                    if ($rootScope.$$phase) {
                        return scope.$eval(attrs.infiniteScroll);
                    } else {
                        return scope.$apply(attrs.infiniteScroll);
                    }
                } else if (shouldScroll) {
                    return checkWhenEnabled = true;
                }
            };

            elem.on('scroll', handler);
            scope.$on('$destroy', function () {
                return $window.off('scroll', handler);
            });
            return $timeout((function () {
                if (attrs.infiniteScrollImmediateCheck) {
                    if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                        return handler();
                    }
                } else {
                    return handler();
                }
            }), 0);
        }
    };
}
]);


angular.module('EMR.Admin').directive('ngClick', ['$timeout', function ($timeout) {

    var delay = 1000;

    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, elem) {
            if (angular.element(elem).prop("tagName").toLowerCase() === "button"
                || (angular.element(elem).prop("tagName").toLowerCase() === "input" && angular.element(elem).prop("type").toLowerCase() === "button")
                || (angular.element(elem).attr("considerasbutton") === "1")) {

                var disabled = false;
                var timeoutPromise = null;

                // Define the click handler separately so it can be removed properly
                function clickHandler(evt) {
                    // Ignore clicks on bootstrap-switch elements
                    if (angular.element(evt.target).closest('.bootstrap-switch').length) {
                        return;
                    }

                    if (disabled) {
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        return;
                    }

                    disabled = true;
                    timeoutPromise = $timeout(function () { 
                        disabled = false; 
                        timeoutPromise = null; // Clear reference
                    }, delay, false);
                }

                // Attach event listener
                elem.on('click', clickHandler);

                // Remove event listener and cancel timeout on directive destruction
                scope.$on('$destroy', function () {
                    elem.off('click', clickHandler);
                    
                    if (timeoutPromise) {
                        $timeout.cancel(timeoutPromise);
                        timeoutPromise = null; // Clear reference
                    }

                    // Immediately re-enable the button
                    disabled = false;
                });
            }
        }
    };
}]);

// angular.module('EMR.Admin').directive('ngClick', ['$timeout', function ($timeout) {

//     var delay = 500;


//     return {
//         restrict: 'A',
//         priority: -1,
//         link: function (scope, elem) {

//             if (angular.element(elem).prop("tagName").toLowerCase() == "button"
// 				|| (angular.element(elem).prop("tagName").toLowerCase() == "input" && angular.element(elem).prop("type").toLowerCase() == "button")
// 				|| (angular.element(elem).attr("considerasbutton") == "1")) {
//                 var disabled = false;

//                 scope.$on('$destroy', function () {
//                     elem.off('click', function (evt) {

//                         //bootstrap-switch bootstrap-switch-medium bootstrap-switch-animate bootstrap-switch-id-chkPatientStatementNotRequired bootstrap-switch-wrapper bootstrap-switch-on bootstrap-switch-focused
//                         if (angular.element(evt.target).hasClass("bootstrap-switch-label") || angular.element(evt.target).hasClass("bootstrap-switch-handle-on") || angular.element(evt.target).hasClass("bootstrap-switch-primary") || angular.element(evt.target).hasClass("bootstrap-switch-handle-off") || angular.element(evt.target).hasClass("bootstrap-switch-default") || angular.element(evt.target).hasClass("bootstrap-switch-container")
// 							|| angular.element(evt.target).hasClass("bootstrap-switch-off") || angular.element(evt.target).hasClass("bootstrap-switch-on") || angular.element(evt.target).hasClass("bootstrap-switch-wrapper") || angular.element(evt.target).hasClass("bootstrap-switch-animate") || angular.element(evt.target).hasClass("bootstrap-switch-medium") || angular.element(evt.target).hasClass("bootstrap-switch")) {

//                         }
//                         else {
//                             if (disabled) {
//                                 evt.preventDefault();
//                                 evt.stopImmediatePropagation();
//                             } else {
//                                 disabled = true;
//                                 $timeout(function () { disabled = false; }, delay, false);
//                             }
//                         }
//                     })
//                 });

//                 elem.on('click', function (evt) {
//                     // Ignore clicks on bootstrap-switch elements
//                     if (angular.element(evt.target).closest('.bootstrap-switch').length) {
//                         return;
//                     }

//                     if (disabled) {
//                         evt.preventDefault();
//                         evt.stopImmediatePropagation();
//                     } else {
//                         disabled = true;
//                         $timeout(function () { disabled = false; }, delay, false);
//                     }
//                 });
//             }
//         }
//     };
// }]);



//<search-patient-field filter-on="1" ng-model="incomingReferralFormat2MainViewClientFirstName" model="incomingReferralFormat2MainViewClientFirstName" option-enter="incomingReferralFormat2MainViewRefreshMainGridData(true, undefined);" focus-me="incomingFocusme"></search-patient-field>

angular.module('EMR.Admin').directive('searchCptCodesServerSide', ['$rootScope', '$window', 'CPTCodesServices', '$parse', '$timeout', function ($rootScope, $window, CPTCodesServices, $parse, $timeout) {
    return {
        require: 'ngModel',
        restrict: 'AE',
        transclude: true,
        template: '<input kendo-auto-complete="nameSearchFieldOptionWidgets" id={{searchCptCodesServerSideElementId}} tabindex="{{controlTabindex}}" ng-model="nameSearchField" k-options="nameSearchFieldOption" ng-blur="nameSearchFieldOnBlur();" ng-enter="nameSearchFieldOnEnter();" style="width: 100%;" />',
        scope: {
            optionModel: "=model",
            optionEnter: '&optionEnter',
            focusMeOption: "=focusMe",
            controlTabindex: "=controltabindex",
            isOnLoad: "=searchcptcodesonload",
            optionBlur: '&optionBlur',
            //optionId: "=optionId",
        },
        link: function ($scope, $elem, $attrs, modelCtrl) {

            var filterOn = $attrs.filterOn; var unbindWatch, unbindWatchOnUsersName;
            //var dataItemField = (filterOn == 1 ? "FirstName" : (filterOn == 2 ? "LastName" : (filterOn == 3 ? "PatientFullName" : "LastName")));
            $scope.searchCptCodesServerSideElementId = $attrs.optionId;
            $scope.searchCptCodesServerSideElementClass = $attrs.optionClass;


            var dataItemField = "CPTCode";
            //if (hasValue($attrs.focusMe)) {

            //var modelFocus = $parse($attrs.focusMe);

            unbindWatch = $scope.$watch('focusMeOption', function (value) {
                //console.log('value=', value);
                if (value === true) {
                    setTimeout(function () {
                        if ($(window).width() > 1024) {
                            if (hasValue($scope.nameSearchFieldOptionWidgets))
                                $scope.nameSearchFieldOptionWidgets.focus();
                        }
                    }, 100);
                }
            });


            unbindWatchOnUsersName = $scope.$watch('optionModel', function (newValue, oldValue) {

                if (newValue != oldValue) {
                    if (!$scope.isScriptRendering) {
                        $scope.nameSearchField = newValue;
                        if ($scope.isOnLoad == false)
                            $scope.firstNameSearchFieldOptionsDataSource.read();
                    }
                }
            });

            $scope.nameSearchFieldOnBlur = function () {
                $scope.focusMeOption = false;
                $timeout(function () {
                    $scope.$apply();
                })
                $scope.optionBlur();
            };




            var schemaModel = {
                CPTCode: function (data) {
                    return data.CPTCode;
                },
            };



            $scope.firstNameSearchFieldOptionsDataSource = new kendo.data.DataSource({
                data: [],
                serverFiltering: true,
                transport: {
                    read: function (options) {

                        var postData = { CPTCode: $scope.nameSearchField };
                        CPTCodesServices.cptCodesGetCPTCodesWithDiscriptionInfo(postData).then(function (serviceResponse) {
                            if (isError(serviceResponse)) return false;
                            options.success(serviceResponse);
                        });
                    }
                },
                schema: schemaModel
            });


            $scope.nameSearchFieldOnEnter = function () {

                $scope.isScriptRendering = true;

                //var model = $parse($attrs.model);
                //$scope.$apply(model.assign($scope, $scope.nameSearchField));

                //var ngModelWatch = $parse($attrs.ngModel);
                //$scope.$apply(ngModelWatch.assign($scope, $scope.nameSearchField));


                //modelCtrl.$setViewValue($scope.nameSearchField);
                //modelCtrl.$render();


                $scope.optionModel = $scope.nameSearchField;

                $timeout(function () {
                    $scope.$apply();
                })
                $scope.optionEnter();

                $scope.isScriptRendering = false;
            };


            $scope.nameSearchFieldOption = {
                dataSource: $scope.firstNameSearchFieldOptionsDataSource,
                dataTextField: dataItemField,
                template: '<span><p>{{dataItem.CPTCode}} - {{dataItem.CPTCodeDescription}}</p></span>',
                filter: "contains",
                dataBound: function (kendoEvent) {
                    $scope.nameSearchFieldOptionWidgets = kendoEvent.sender;

                    if (hasValue($scope.searchCptCodesServerSideElementId) && hasValue($scope.searchCptCodesServerSideElementClass) &&
						hasValue(!$("#" + $scope.searchCptCodesServerSideElementId + "-list").hasClass($scope.searchCptCodesServerSideElementClass)))
                        $("#" + $scope.searchCptCodesServerSideElementId + "-list").addClass($scope.searchCptCodesServerSideElementClass);

                    //if (hasValue($scope.optionid) && hasValue(!$("#" + $scope.optionid + "-list").hasClass("BillingDoubleDollarSearchCptCodesServerSideDropDownWidth")))
                    //    $("#" + $scope.optionid + "-list").addClass("BillingDoubleDollarSearchCptCodesServerSideDropDownWidth");


                    //if (hasValue($scope.optionid) && hasValue(!$("#searchCptCodesServerSide-list").hasClass("BillingDoubleDollarSearchCptCodesServerSideDropDownWidth")))
                    //    $("#searchCptCodesServerSide-list").addClass("BillingDoubleDollarSearchCptCodesServerSideDropDownWidth");

                },
                change: function (kendoEvent) {
                    if (hasValue(this.dataItem(kendoEvent.item))) {
                        $scope.nameSearchField = this.dataItem(kendoEvent.item)[dataItemField];
                    } else {
                        $scope.nameSearchField = this.value();
                    }


                    $scope.nameSearchFieldOnEnter();
                },
                select: function (kendoEvent) {
                    if (hasValue(this.dataItem(kendoEvent.item))) {
                        $scope.nameSearchField = this.dataItem(kendoEvent.item)[dataItemField];
                    } else {
                        $scope.nameSearchField = this.value();
                    }


                    $scope.nameSearchFieldOnEnter();
                }
            };

            $elem.on('$destroy', function () {
                if (unbindWatch)
                    unbindWatch();//unbinding watch

                unbindWatchOnUsersName();
            });


        }
    }

}]);






angular.module('EMR.Admin').factory('HelperFull', function () {
    return {
        closestSlider: function (elem) {
            var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
            if (matchesSelector.bind(elem)('I')) {
                return elem.parentNode;
            }
            return elem;
        },
        getOffset: function (elem, fixedPosition) {
            var
				x = 0,
				y = 0,
				scrollX = 0,
				scrollY = 0;
            while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
                x += elem.offsetLeft;
                y += elem.offsetTop;
                if (!fixedPosition && elem.tagName === 'BODY') {
                    scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
                    scrollY += document.documentElement.scrollTop || elem.scrollTop;
                } else {
                    scrollX += elem.scrollLeft;
                    scrollY += elem.scrollTop;
                }
                elem = elem.offsetParent;
            }
            return {
                top: y,
                left: x,
                scrollX: scrollX,
                scrollY: scrollY
            };
        },
        // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
        stringParsers: [
			{
			    re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
			    parse: function (execResult) {
			        return [
						execResult[1],
						execResult[2],
						execResult[3],
						execResult[4]
			        ];
			    }
			},
			{
			    re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
			    parse: function (execResult) {
			        return [
						2.55 * execResult[1],
						2.55 * execResult[2],
						2.55 * execResult[3],
						execResult[4]
			        ];
			    }
			},
			{
			    re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
			    parse: function (execResult) {
			        return [
						parseInt(execResult[1], 16),
						parseInt(execResult[2], 16),
						parseInt(execResult[3], 16)
			        ];
			    }
			},
			{
			    re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
			    parse: function (execResult) {
			        return [
						parseInt(execResult[1] + execResult[1], 16),
						parseInt(execResult[2] + execResult[2], 16),
						parseInt(execResult[3] + execResult[3], 16)
			        ];
			    }
			}
        ]
    };
}).factory('ColorFull', ['HelperFull', function (HelperFull) {
    return {
        value: {
            h: 1,
            s: 1,
            b: 1,
            a: 1
        },
        // translate a format from Color object to a string
        'rgb': function () {
            var rgb = this.toRGB();
            return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
        },
        'rgba': function () {
            var rgb = this.toRGB();
            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
        },
        'hex': function () {
            return this.toHex();
        },

        // HSBtoRGB from RaphaelJS
        RGBtoHSB: function (r, g, b, a) {
            r /= 255;
            g /= 255;
            b /= 255;

            var H, S, V, C;
            V = Math.max(r, g, b);
            C = V - Math.min(r, g, b);
            H = (C === 0 ? null :
				V === r ? (g - b) / C :
					V === g ? (b - r) / C + 2 :
						(r - g) / C + 4
			);
            H = ((H + 360) % 6) * 60 / 360;
            S = C === 0 ? 0 : C / V;
            return { h: H || 1, s: S, b: V, a: a || 1 };
        },

        //parse a string to HSB
        setColor: function (val) {

            if (hasValue(val)) {
                val = val.toLowerCase();
                for (var key in HelperFull.stringParsers) {
                    if (HelperFull.stringParsers.hasOwnProperty(key)) {
                        var parser = HelperFull.stringParsers[key];
                        var match = parser.re.exec(val),
							values = match && parser.parse(match);
                        if (values) {
                            this.value = this.RGBtoHSB.apply(null, values);
                            return false;
                        }
                    }
                }
            }
            else {
                val = "";
                this.value = {};
            }

        },

        setHue: function (h) {
            this.value.h = 1 - h;
        },

        setSaturation: function (s) {
            this.value.s = s;
        },

        setLightness: function (b) {
            this.value.b = 1 - b;
        },

        setAlpha: function (a) {
            this.value.a = parseInt((1 - a) * 100, 10) / 100;
        },

        // HSBtoRGB from RaphaelJS
        // https://github.com/DmitryBaranovskiy/raphael/
        toRGB: function (h, s, b, a) {
            if (!h) {
                h = this.value.h;
                s = this.value.s;
                b = this.value.b;
            }
            h *= 360;
            var R, G, B, X, C;
            h = (h % 360) / 60;
            C = b * s;
            X = C * (1 - Math.abs(h % 2 - 1));
            R = G = B = b - C;

            h = ~~h;
            R += [C, X, 0, 0, X, C][h];
            G += [X, C, C, X, 0, 0][h];
            B += [0, 0, X, C, C, X][h];
            return {
                r: Math.round(R * 255),
                g: Math.round(G * 255),
                b: Math.round(B * 255),
                a: a || this.value.a
            };
        },

        toHex: function (h, s, b, a) {
            var rgb = this.toRGB(h, s, b, a);
            return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
        }
    };
}]).directive('colorpicker', ['ColorFull', '$timeout', function (ColorFull, $timeout) {
    return ({
        require: 'ngModel',

        link: {
            //this method executes when the link function has started
            pre: function preLink($scope, iElement, attrs, ngModel, controller) {

            },
            //after compilation/binding of the data has completed this method is executed
            post: function postLink($scope, iElement, attrs, ngModel, controller) {

                //iElement.on('$destroy', function () {
                //    if (unbindWatcherInstance)
                //        unbindWatcherInstance();
                //});

                var unbindWatcherInstance;

                $scope.$on("$destroy", function () {

                    if (unbindWatcherInstance)
                        unbindWatcherInstance();

                    ColorFullPickerInstance.setColor("");
                });



                var thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex', ColorFullPickerInstance = ColorFull;

                var thisPosition = attrs.colorpickerPosition;

                var curValue = (!hasValue(ngModel.$viewValue) || isNaN(ngModel.$viewValue)) ? "" : ngModel.$viewValue;

                if (hasValue(curValue))
                    ColorFullPickerInstance.setColor(curValue);


                if (ngModel) {
                    ngModel.$render = function () {
                        iElement.val(ngModel.$viewValue);
                    };
                    unbindWatcherInstance = $scope.$watch(attrs.ngModel, function () {

                        curValue = ngModel.$viewValue;
                        hasValue(curValue) ? ColorFullPickerInstance['hex']() : "";

                        if (hasValue($(iElement).data("evol-colorpicker"))) {
                            $(iElement).colorpicker("val", curValue);
                        }
                        iElement.parent().css("width", "inherit");
                    });
                }

                $(iElement).colorpicker({
                    hideButton: true,
                    "val": hasValue(curValue) ? ColorFullPickerInstance['hex']() : "",
                    position: hasValue(thisPosition) ? thisPosition : "bottom"
                });

                $(iElement).on("change.color", function (event, color) {

                    var newColor = color ? color : this.value;

                    ColorFullPickerInstance.setColor(newColor);

                    if (hasValue(newColor)) {
                        //if (thisFormat == 'hex') {
                        //    newColor = color;
                        //}
                        //else if (thisFormat == 'rgb') {
                        //    newColor =  ColorFullPickerInstance.rgb;
                        //}
                        //else if (thisFormat == 'rgba') {
                        newColor = ColorFullPickerInstance[thisFormat]();
                        //}
                    }




                    if (ngModel) {
                        //upgrade to 1.7.2
                        $timeout(function () {

                            $scope.$apply(ngModel.$setViewValue(newColor));
                        });

                    }
                    iElement.parent().css("width", "inherit");
                });

            }
        }

    });
}]);






/// this directive was useful in creating the grid with given input options
angular.module('EMR.Admin').directive('ehrResponsiveGrid', ['$timeout', function ($timeout) {


    return {
        restrict: 'AE',
        transclude: true,
        templateUrl: GetEMRPageURLByPageName("EMRWEB/Common/EHRResponsiveGrid.html"),
        scope: {
            /* NOTE: Normally I would set my attributes and bindings
            to be the same name but I wanted to delineate between 
            parent and isolated scope. */
            //isolatedAttributeFoo:'@attributeFoo',
            gridoptions: '=options',//this is readed from the controller
            // isolatedExpressionFoo:'&'
        },

        link: function ($scope, $element, $attrs) {

            var unbindme = $scope.$watch('gridoptions', function () {


                $element.find('.k-grid-content').unbind('scroll.test1');
                $element.find('.k-grid-content').bind('scroll.test1', function () {
                    $element.find('.k-grid-header').scrollLeft(this.scrollLeft);
                    $element.find('.k-grid-header')[0].scrollTop = this.scrollTop;
                });


                $scope.gridoptionsdatasource = $scope.gridoptions.dataSource.data();

                if ($scope.gridoptions.change) {
                    $element.find('.k-grid-content').unbind('click.changeevent');
                    $element.find('.k-grid-content').bind('click.changeevent', "tr", function (event) {
                        $scope.gridoptions.change.apply(event);
                    });
                }

            });


            $element.on("$destroy", function () {
                unbindme();
                $element.find('.k-grid-content').unbind('scroll.test1');
                $element.find('.k-grid-content').unbind('click.changeevent');
            });
        }

    };

}]);


    // Centralized SlimSelect <-> ngModel bridge. Drop-in replacement for a
    // plain <select ng-model> anywhere in the app, controller-as ("vm.foo")
    // or classic ($scope.foo) — ng-model works the same either way, nothing
    // here treats them differently.
    //
    // Usage:
    //   <select slim-select
    //           ng-model="vm.answer"
    //           slim-select-data="vm.answerOptions"
    //           slim-select-settings="vm.slimSettings"      (optional)
    //           slim-select-disabled="vm.isReadOnly"        (optional)
    //           slim-select-change="vm.onAnswerChange(value)"> (optional)
    //     <option></option>
    //   </select>
    //
    // Multi-select: add the native `multiple` attribute to the <select> and
    // bind ng-model to an array; the model then holds/receives arrays
    // instead of a single value.
    //
    // IMPORTANT — read before adding ng-required, ng-disabled, ng-change,
    // ng-show or ng-hide to a slim-select element:
    // Normally, putting ng-model on a <select> also silently pulls in
    // Angular's own built-in "select" helper, which manages that select's
    // value and listens for the browser's native change event on it.
    // SlimSelect manages that same native <select> itself, and also listens
    // for its native change event to redraw its own custom-looking dropdown.
    // Having both of those watch and react to the same element at once causes
    // a visible glitch — one of them updates the select while the other is
    // still mid-update, and the dropdown briefly shows the wrong thing.
    //
    // To avoid that, this directive is marked `terminal: true`, which tells
    // Angular "don't attach any of your own priority-0-or-lower behavior to
    // this element." That removes the conflict, but it also means ng-model,
    // ng-required, ng-disabled, ng-change, ng-show and ng-hide placed
    // directly on this same <select> element will silently do nothing.
    // Use slim-select-disabled / slim-select-change instead of
    // ng-disabled / ng-change. For ng-show / ng-hide, wrap the <select> in a
    // parent element and put ng-show/ng-hide on that wrapper instead — this
    // also avoids a separate issue where SlimSelect draws its own visible
    // dropdown next to the real (hidden) <select>, so hiding just the
    // <select> wouldn't hide what's actually on screen anyway. There is no
    // supported replacement for ng-required / Angular's built-in form
    // validation on a slim-select element.

angular.module('EMR.Admin').directive('slimSelect', ['$parse', function ($parse) {

    return {
            restrict: 'A',
            priority: 10,
            terminal: true,
            controller: angular.noop,
            require: 'slimSelect',
            link: function (scope, element, attrs, ctrl) {
                const selectElement = element[0];
                const isMultiple = !!selectElement.multiple;
                let instance;

                const dataGetter = attrs.slimSelectData ? $parse(attrs.slimSelectData) : angular.noop;
                const settingsGetter = attrs.slimSelectSettings ? $parse(attrs.slimSelectSettings) : angular.noop;
                const changeHandler = attrs.slimSelectChange ? $parse(attrs.slimSelectChange) : null;

                const hasModel = !!attrs.ngModel;
                const modelGetter = hasModel ? $parse(attrs.ngModel) : angular.noop;
                const modelSetter = hasModel && modelGetter.assign ? modelGetter.assign : null;
                // Remembers the value this directive itself just wrote to the model, so the
                // "did the model change from outside?" watch below can tell "that's just the
                // change I made a moment ago" (ignore it) apart from "something else changed
                // this value, e.g. a saved answer loading in" (apply it to the dropdown).
                let lastSyncedValue;

                function currentData() { return dataGetter(scope) || []; }
                function currentSettings() { return settingsGetter(scope) || {}; }

                function valueToArray(value) {
                    if (value == null || value === '') { return []; }
                    return angular.isArray(value) ? value.map(String) : [value.toString()];
                }

                // Tells SlimSelect which option(s) to show as selected, based on the model
                // value. Only values that actually exist in the current option list are
                // applied, so a stale/unknown saved value doesn't leave the dropdown stuck
                // showing something that isn't a real option.
                function applySelectionByValue(value) {
                    const data = currentData();
                    const wanted = valueToArray(value).filter(function (v) {
                        return data.some(function (item) { return item.value != null && item.value.toString() === v; });
                    });
                    instance.setSelected(wanted);
                }

                function readSelectedValue(selected) {
                    if (!selected || !selected.length) { return isMultiple ? [] : null; }
                    return isMultiple ? selected.map(function (o) { return o.value; }) : selected[0].value;
                }

                // Pushes a new value into the model and, if slim-select-change was given,
                // calls that too. Deferred with $applyAsync so it plays nicely no matter
                // where in Angular's update cycle this gets called from.
                function writeModel(value) {
                    lastSyncedValue = value;
                    if (modelSetter) {
                        scope.$applyAsync(function () { modelSetter(scope, value); });
                    }
                    if (changeHandler) {
                        scope.$applyAsync(function () { changeHandler(scope, { value: value }); });
                    }
                }

                // Assigned before construction so a sibling directive requiring this
                // controller (ctrl.getInstance/reset/refresh) gets safe no-ops instead of a
                // "not a function" crash if SlimSelect fails to construct below.
                ctrl.getInstance = function () { return null; };
                ctrl.reset = angular.noop;
                ctrl.refresh = angular.noop;

                try {
                    instance = new SlimSelect({
                        select: selectElement,
                        settings: angular.extend({
                            showSearch: currentData().length > 7,
                            closeOnSelect: !isMultiple
                        }, currentSettings()),
                        data: currentData(),
                        events: {
                            afterChange: function (selected) {
                                writeModel(readSelectedValue(selected));
                            }
                        }
                    });
                } catch (e) {
                    // Leaving this as a sentinel comment rather than deleting: the stylesheet
                    // hides selects that don't have data-ss-init set, so clearing it here would
                    // leave a failed dropdown invisible instead of showing something is wrong.
                    console.error('slimSelect: failed to initialize SlimSelect on element', selectElement, e);
                    return;
                }

                //selectElement.dataset.ssInit = '1';
                selectElement.__slimSelectInstance = instance;
                // Lets code that only has the DOM node (not the Angular scope) clear this
                // dropdown, e.g. a Reset button. Prefer requiring the 'slimSelect' controller
                // (ctrl.reset) from a sibling directive when you have access to that instead.
                selectElement.__slimSelectReset = function () {
                    instance.setSelected([]);
                    writeModel(isMultiple ? [] : null);
                };

                ctrl.getInstance = function () { return instance; };
                ctrl.reset = selectElement.__slimSelectReset;
                ctrl.refresh = function (data) { instance.setData(data || []); };

                // Rebuild the dropdown's option list whenever slim-select-data is pointed at a
                // new array (e.g. the options load in later from the server).
                if (attrs.slimSelectData) {
                    scope.$watchCollection(attrs.slimSelectData, function (newData, oldData) {
                        if (newData === oldData) { return; }
                        instance.setData(newData || []);
                    });
                }

                // Stand-in for ng-disabled, which doesn't work directly on this element (see
                // the big comment at the top of this file for why).
                if (attrs.slimSelectDisabled) {
                    scope.$watch(attrs.slimSelectDisabled, function (isDisabled) {
                        selectElement.disabled = !!isDisabled;
                        try {
                            if (isDisabled && instance.disable) { instance.disable(); }
                            else if (!isDisabled && instance.enable) { instance.enable(); }
                        } catch (e) {
                            // Some SlimSelect versions don't have enable()/disable(); the plain
                            // "disabled" attribute set above still works as a fallback.
                        }
                    });
                }

                // On load, show whatever the model already holds (e.g. a previously saved
                // answer). After that, keep watching in case the model changes from outside
                // this directive (e.g. a saved answer arriving later from the server). The
                // lastSyncedValue check stops this from re-applying a change we just made
                // ourselves a moment ago in writeModel above.
                if (hasModel) {
                    lastSyncedValue = modelGetter(scope);
                    applySelectionByValue(lastSyncedValue);

                    scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                        if (newVal === oldVal || newVal === lastSyncedValue) { return; }
                        lastSyncedValue = newVal;
                        applySelectionByValue(newVal);
                    }, isMultiple);
                }

                scope.$on('$destroy', function () {
                    delete selectElement.__slimSelectInstance;
                    delete selectElement.__slimSelectReset;
                    instance.destroy();
                });
            }
        };

}]);




///// this directive was useful in creating the grid with given input options
//angular.module('EMR.Admin').directive('ehrPasswordRule', ['$timeout', function ($timeout) {

//    return {
//        templateUrl: '<input id="ehrPassword" name="password" type="passw0rd" ng-trim="false" ng-model="password.value" ng-change="onPasswordChange(password)">' +
//                                '<div id="PasswordMessage" ng-hide="ehrPasswordShowRules" style="display:none;">'+
//                                '<h4>Password must include:</h4>'+
//                                '<ul>'+
//                                    '<li id="letter" class="invalid">8-20 <strong>Characters</strong></li>'+
//                                    '<li id="capital" class="invalid">At least <strong>one capital letter</strong></li>'+
//                                    '<li id="number" class="invalid">At least <strong>one number</strong></li>'+
//                                    '<li id="length" class="invalid">No spaces</li>'+
//                                '</ul>' +
//                            '</div>',
//        restrict: 'AE',
//        scope: {},
//        controller: function ($scope) {

//            $scope.password = {
//                status: 'Invalid',
//                value: '',
//                meterWidth: 0,
//                type: 'password',
//                rules: {
//                    isValidLength: false,
//                    hasNumber: false,
//                    hasLetter: false,
//                    noSpecialChar: false
//                }
//            };

//            //set default values
//            this.setDefault = function (password) {
//                password.rules.hasNumber = false;
//                password.rules.hasLetter = false;
//                password.rules.isValidLength = false;
//                password.rules.noSpecialChar = true;
//                $scope.password.meterWidth = 25;
//            };


//            //this.getMeterWidth = function (password) {
//            //    var property_count = 0,
//            //    valid_property_count = 0,
//            //    property;
//            //    for (property in password.rules) {
//            //        if (password.rules.hasOwnProperty(property)) {
//            //            property_count = property_count + 1;
//            //            if (password.rules[property]) {
//            //                valid_property_count =
//            //                    valid_property_count + 1;
//            //            }
//            //        }
//            //    }
//            //    return (valid_property_count / property_count) * 100;
//            //};


//            this.getStatus = function (password) {
//                if (100 === password.meterWidth) {
//                    return 'Valid';
//                }
//                return 'Invalid';
//            };
//        },
//        link: function ($scope, $element, $attrs, $ctrl) {
//            $ctrl.setDefault($scope.password);
//            //listen to password change
//            $scope.onPasswordChange = function (password) {
//                $ctrl.setDefault(password);
//                //set password rules if valid or invalid using regex
//                if (password.value) {
//                    password.rules.hasNumber =
//                            password.value.match(/\d/) ? true : false;
//                    password.rules.hasLetter =
//                            password.value.match(/[A-z]/) ? true : false;
//                    password.rules.isValidLength =
//                            password.value.match(/^.{8,}$/) ? true : false;
//                    password.rules.noSpecialChar =
//                            !password.value.match(/[ /"]/) ? true : false;
//                }
//                password.meterWidth = $ctrl.getMeterWidth(password);
//                password.status = $ctrl.getStatus(password);
//            };
//        }
//    };
  

//}]);

